// =============================================================================
// scripts.js - ProtectCar Motors / Tapetes Exclusive (versão limpa e estável)
// =============================================================================

document.addEventListener("DOMContentLoaded", () => {

  // ===========================================================================
  // 1. ANO NO FOOTER
  // ===========================================================================
  const yearEl = document.getElementById("year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  // ===========================================================================
  // 2. MENU / DRAWER + MODAIS (header)
  // ===========================================================================
  const qs = s => document.querySelector(s);
  const overlay = qs("#hxOverlay");
  const drawer = qs("#hxDrawer");
  const btnMenu = qs("#btnMenu");
  const btnClose = qs("#btnClose");
  const btnAccount = qs("#btnAccount");
  const accountModal = qs("#accountModal");
  const btnAccountClose = qs("#btnAccountClose");
  const accountForm = qs("#accountForm");
  const btnCart = qs("#btnCart");
  const cartModal = qs("#cartModal");
  const btnCartClose = qs("#btnCartClose");
  const btnCartGo = qs("#btnCartGo");
  const searchForm = qs("#searchForm");
  const searchInput = qs("#searchInput");
  const searchModal = qs("#searchModal");
  const btnSearchClose = qs("#btnSearchClose");
  const searchResultText = qs("#searchResultText");
  const searchList = qs("#searchList");

  let lastFocus = null;

  const lockScroll = on => {
    // body é o scroll container real (overflow:auto), precisa travar nele também
    document.documentElement.style.overflow = on ? "hidden" : "";
    document.body.style.overflow = on ? "hidden" : "";
  };

  function openOverlay() {
    if (overlay) overlay.hidden = false;
  }

  function closeOverlayIfNoneOpen() {
    if (!overlay) return;
    const somethingOpen =
      drawer?.classList.contains("isOpen") ||
      accountModal?.classList.contains("isOpen") ||
      cartModal?.classList.contains("isOpen") ||
      searchModal?.classList.contains("isOpen");
    if (!somethingOpen) overlay.hidden = true;
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    // Menu 18 (desce do topo): o painel abre logo abaixo do cabeçalho, que continua visível com o X
    if (window.msPrenderCabecalho) window.msPrenderCabecalho(true);
    const cabecalho = document.querySelector(".hxHeader");
    if (cabecalho) drawer.style.setProperty("--menu-topo", Math.max(0, Math.round(cabecalho.getBoundingClientRect().bottom)) + "px");
    document.documentElement.classList.add("menuAberto");
    drawer.classList.add("isOpen");
    drawer.setAttribute("aria-hidden", "false");
    btnMenu?.setAttribute("aria-expanded", "true");
    openOverlay();
    lockScroll(true);
    setTimeout(() => drawer.focus(), 0);
  }

  function closeDrawer() {
    if (!drawer) return;
    document.documentElement.classList.remove("menuAberto");
    if (window.msPrenderCabecalho) window.msPrenderCabecalho(false);
    drawer.classList.remove("isOpen");
    drawer.setAttribute("aria-hidden", "true");
    btnMenu?.setAttribute("aria-expanded", "false");
    closeOverlayIfNoneOpen();
    lockScroll(false);
    if (lastFocus) lastFocus.focus();
  }

  function openModal(modal) {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.classList.add("isOpen");
    modal.setAttribute("aria-hidden", "false");
    openOverlay();
    lockScroll(true);
    const first = modal.querySelector("input, button");
    setTimeout(() => first?.focus(), 0);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove("isOpen");
    modal.setAttribute("aria-hidden", "true");
    closeOverlayIfNoneOpen();
    lockScroll(false);
    if (lastFocus) lastFocus.focus();
  }

  // Eventos do menu
  btnMenu?.addEventListener("click", () => (drawer?.classList.contains("isOpen") ? closeDrawer() : openDrawer()));
  btnClose?.addEventListener("click", closeDrawer);
  drawer?.querySelectorAll("a").forEach(a => a.addEventListener("click", closeDrawer));

  // Conta
  btnAccount?.addEventListener("click", () => openModal(accountModal));
  btnAccountClose?.addEventListener("click", () => closeModal(accountModal));
  accountModal?.addEventListener("click", e => {
    if (e.target === accountModal) closeModal(accountModal);
  });
  accountForm?.addEventListener("submit", e => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(accountForm).entries());
    localStorage.setItem("hx_account", JSON.stringify(data));
    closeModal(accountModal);
  });

  // Carrinho
  btnCart?.addEventListener("click", () => (window.msCarrinho ? window.msCarrinho.abrir() : openModal(cartModal)));
  btnCartClose?.addEventListener("click", () => closeModal(cartModal));
  cartModal?.addEventListener("click", e => {
    if (e.target === cartModal) closeModal(cartModal);
  });
  btnCartGo?.addEventListener("click", () => {
    closeModal(cartModal);
    window.location.hash = "#bandeja";
  });

  // Busca (com resultados fake)
  searchForm?.addEventListener("submit", e => {
    e.preventDefault();
    const q = (searchInput?.value || "").trim();
    openModal(searchModal);
    searchList.innerHTML = "";
    if (!q) {
      searchResultText.textContent = "Veuillez saisir votre recherche.";
      return;
    }
    searchResultText.textContent = `Résultats pour : "${q}"`;
    const items = [
      { title: "Tapis 3D à rebords", note: "Protection intégrale • Rebords hauts" },
      { title: "Tapis de coffre", note: "Finition de qualité" },
      { title: "Kit intérieur + coffre", note: "Kit complet • Meilleur prix" }
    ];
    items
      .filter(i => i.title.toLowerCase().includes(q.toLowerCase()) || q.length < 3)
      .forEach(i => {
        const div = document.createElement("div");
        div.className = "hxResult";
        div.innerHTML = `<div><strong>${i.title}</strong><br><span>${i.note}</span></div><span>→</span>`;
        div.addEventListener("click", () => {
          closeModal(searchModal);
          if (i.title.includes("Wannenmatte")) window.location.hash = "#bandeja";
          else if (i.title.includes("coffre")) window.location.hash = "#mala";
          else window.location.hash = "#kit";
        });
        searchList.appendChild(div);
      });
  });

  btnSearchClose?.addEventListener("click", () => closeModal(searchModal));
  searchModal?.addEventListener("click", e => {
    if (e.target === searchModal) closeModal(searchModal);
  });

  // Overlay e ESC fecham tudo
  overlay?.addEventListener("click", () => {
    if (drawer?.classList.contains("isOpen")) closeDrawer();
    if (accountModal?.classList.contains("isOpen")) closeModal(accountModal);
    if (cartModal?.classList.contains("isOpen")) closeModal(cartModal);
    if (searchModal?.classList.contains("isOpen")) closeModal(searchModal);
  });

  document.addEventListener("keydown", e => {
    if (e.key !== "Escape") return;
    if (drawer?.classList.contains("isOpen")) closeDrawer();
    if (accountModal?.classList.contains("isOpen")) closeModal(accountModal);
    if (cartModal?.classList.contains("isOpen")) closeModal(cartModal);
    if (searchModal?.classList.contains("isOpen")) closeModal(searchModal);
  });

  // ===========================================================================
  // 3. HERO SLIDER
  // ===========================================================================
  const track = document.getElementById("heroTrack");
  const viewport = document.getElementById("heroViewport");
  const dots = Array.from(document.querySelectorAll(".heroDot"));
  const total = dots.length;
  let index = 0;
  let timer = null;

  function setActiveDot(i) {
    dots.forEach(d => d.classList.remove("isActive"));
    dots[i]?.classList.add("isActive");
  }

  function goTo(i) {
    index = (i + total) % total;
    if (track) track.style.transform = `translateX(-${index * 100}%)`;
    setActiveDot(index);
  }

  function start() {
    stop();
    timer = setInterval(() => goTo(index + 1), 5000);
  }

  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      goTo(i);
      start();
    });
  });

  let startX = 0;
  viewport?.addEventListener("touchstart", e => {
    startX = e.touches[0].clientX;
    stop();
  }, { passive: true });

  viewport?.addEventListener("touchend", e => {
    const endX = e.changedTouches[0].clientX;
    const dx = startX - endX;
    if (dx > 45) goTo(index + 1);
    else if (dx < -45) goTo(index - 1);
    start();
  }, { passive: true });

  if (track && viewport) {
    goTo(0);
    start();
  }

  // ===========================================================================
  // 4. REVEAL ON SCROLL (animações ao entrar na tela)
  // ===========================================================================
  const revealItems = document.querySelectorAll(".reveal");
  if (revealItems.length) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("isVisible");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: "0px 0px -8% 0px" });

    revealItems.forEach(el => obs.observe(el));
  }

  // ===========================================================================
  // 5. TICKER INFINITO (barra superior)
  // ===========================================================================
  /*
   * Clona o set base até cobrir a viewport e anda exatamente a largura de UM
   * set. Com os 2 sets fixos do HTML, em ecrãs largos o conteúdo acabava antes
   * do fim do ecrã: via-se espaço vazio e a faixa parecia "voltar a meio".
   */
  const tickerTrack = document.getElementById("rxTickerTrack");
  if (tickerTrack) {
    const baseSet = tickerTrack.querySelector(".rxTicker__set");

    if (baseSet) {
      let tickerDebounce;

      function buildTicker() {
        // Reduz a um só set antes de reconstruir - senão os clones acumulam
        tickerTrack.querySelectorAll(".rxTicker__set").forEach((el, i) => {
          if (i > 0) el.remove();
        });

        const unit = baseSet.getBoundingClientRect().width;
        if (!unit) return;

        const needed = Math.max(2, Math.ceil(window.innerWidth / unit) + 1);
        for (let i = 1; i < needed; i++) {
          const clone = baseSet.cloneNode(true);
          clone.setAttribute("aria-hidden", "true");
          tickerTrack.appendChild(clone);
        }

        const speed = 90; // px/s
        tickerTrack.style.setProperty("--rx-shift", `${unit}px`);
        tickerTrack.style.animationDuration = `${Math.max(12, unit / speed)}s`;
      }

      function scheduleTickerBuild() {
        clearTimeout(tickerDebounce);
        tickerDebounce = setTimeout(buildTicker, 180);
      }

      buildTicker();
      window.addEventListener("load", buildTicker);
      window.addEventListener("resize", scheduleTickerBuild);

      // As fontes só carregam depois do primeiro build e mudam a largura do
      // set - sem isto o --rx-shift fica desatualizado e o loop dá um salto.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(buildTicker);
      }

      // Apanha mudanças de largura que o evento resize não cobre (rotação,
      // zoom, aparecimento da scrollbar, reflow do layout).
      if (window.ResizeObserver) {
        new ResizeObserver(scheduleTickerBuild).observe(tickerTrack.parentElement || tickerTrack);
      }
    }
  }

  // ===========================================================================
  // 6. BEFORE / AFTER (arrastar para comparar)
  // ===========================================================================
  document.querySelectorAll(".cmp").forEach(cmp => {
    const drag = cmp.querySelector(".cmp__drag");
    const after = cmp.querySelector(".cmp__after");
    const beforeUrl = cmp.getAttribute("data-before");
    const afterUrl = cmp.getAttribute("data-after");

    // As duas fotos só baixam quando o comparador chega perto da tela.
    const carregarFotos = () => {
      if (beforeUrl) cmp.style.backgroundImage = `url(${beforeUrl})`;
      if (after && afterUrl) after.style.backgroundImage = `url(${afterUrl})`;
    };
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((es) => {
        if (es.some(e => e.isIntersecting)) { carregarFotos(); io.disconnect(); }
      }, { rootMargin: "500px 0px" });
      io.observe(cmp);
    } else {
      carregarFotos();
    }

    let isDown = false;

    function pctFromClientX(clientX) {
      const r = cmp.getBoundingClientRect();
      const x = Math.min(Math.max(clientX - r.left, 0), r.width);
      return (x / r.width) * 100;
    }

    function setP(p) {
      cmp.style.setProperty("--p", `${p}%`);
    }

    setP(50); // inicia no meio

    drag?.addEventListener("mousedown", e => {
      isDown = true;
      setP(pctFromClientX(e.clientX));
    });

    window.addEventListener("mousemove", e => {
      if (!isDown) return;
      setP(pctFromClientX(e.clientX));
    });

    window.addEventListener("mouseup", () => { isDown = false; });

    drag?.addEventListener("touchstart", e => {
      isDown = true;
      setP(pctFromClientX(e.touches[0].clientX));
    }, { passive: true });

    drag?.addEventListener("touchmove", e => {
      if (!isDown) return;
      setP(pctFromClientX(e.touches[0].clientX));
    }, { passive: true });

    drag?.addEventListener("touchend", () => { isDown = false; }, { passive: true });

    // ── Auto-animation: sweeps 15→85→15 in loop, pauses on user touch ──
    let autoP = 50;
    let autoDir = 1;
    let autoPaused = false;
    let resumeTimer = null;
    const SPEED = 0.22;
    const AMIN = 15, AMAX = 85;

    function pauseAuto(ms) {
      autoPaused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => { autoPaused = false; }, ms || 3500);
    }

    drag?.addEventListener("mousedown", () => pauseAuto(4000));
    drag?.addEventListener("touchstart", () => pauseAuto(4000), { passive: true });

    function autoStep() {
      if (!autoPaused && !isDown) {
        autoP += SPEED * autoDir;
        if (autoP >= AMAX) { autoP = AMAX; autoDir = -1; }
        if (autoP <= AMIN) { autoP = AMIN; autoDir =  1; }
        setP(autoP);
      }
      requestAnimationFrame(autoStep);
    }

    const _obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { autoStep(); _obs.disconnect(); }
      });
    }, { threshold: 0.3 });
    _obs.observe(cmp);
  });

 

  // ===========================================================================
  // 8. POPUP CUPOM (2 etapas)
  // ===========================================================================
  (function initRvPop() {
    const pop = document.getElementById("rvPop");
    if (!pop) return;

    const step1 = document.getElementById("rvPopStep1");
    const step2 = document.getElementById("rvPopStep2");
    const form = document.getElementById("rvPopForm");
    const copyBtn = document.getElementById("rvCopyCoupon");
    const codeEl = document.getElementById("rvCouponCode");
    const copiedEl = document.getElementById("rvCopied");

    const POP_SEEN_KEY = "rv_coupon_popup_opened_at";
    const COOLDOWN_HOURS = 12;

    function canShowPopup() {
      try {
        const last = Number(localStorage.getItem(POP_SEEN_KEY) || "0");
        if (!last) return true;
        return (Date.now() - last) / (1000 * 60 * 60) >= COOLDOWN_HOURS;
      } catch {
        return true;
      }
    }

    function markPopupOpened() {
      try {
        localStorage.setItem(POP_SEEN_KEY, String(Date.now()));
      } catch {}
    }

    function openPop() {
      markPopupOpened();
      pop.classList.add("is-open");
      pop.setAttribute("aria-hidden", "false");
      if (step1) step1.hidden = false;
      if (step2) step2.hidden = true;
    }

    function closePop() {
      pop.classList.remove("is-open");
      pop.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      if (copiedEl) copiedEl.hidden = true;
    }

    pop.addEventListener("click", e => {
      if (e.target?.dataset?.rvclose === "1") closePop();
    });

    form?.addEventListener("submit", e => {
      e.preventDefault();
      if (step1) step1.hidden = true;
      if (step2) step2.hidden = false;
    });

    copyBtn?.addEventListener("click", async () => {
      const code = codeEl?.textContent?.trim() || "";
      try {
        await navigator.clipboard.writeText(code);
      } catch {
        const ta = document.createElement("textarea");
        ta.value = code;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
      }
      if (copiedEl) {
        copiedEl.hidden = false;
        setTimeout(() => copiedEl.hidden = true, 1800);
      }
    });

    if (canShowPopup()) {
      setTimeout(openPop, 700);
    }
  })();

  // ===========================================================================
  // 9. FRETE ESTIMADO (nxShip)
  // ===========================================================================
  (function initNxShip() {
    const box = document.getElementById("nxShip");
    const cityEl = document.getElementById("nxShipCity");
    const etaEl = document.getElementById("nxShipEta");
    if (!box || !cityEl || !etaEl) return;

    const pad2 = n => (n < 10 ? "0" + n : "" + n);
    const meses = ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"];

    function rangeDatas(prazoIni, prazoFim) {
      const now = new Date();
      const a = new Date(now); a.setDate(now.getDate() + prazoIni);
      const b = new Date(now); b.setDate(now.getDate() + prazoFim);
      return `${pad2(a.getDate())}. ${meses[a.getMonth()]} au ${pad2(b.getDate())}. ${meses[b.getMonth()]}`;
    }

    // Mostra imediatamente (sem loading)
    const dateRange = rangeDatas(2, 7);
    cityEl.textContent = "votre région";
    etaEl.innerHTML = `Livraison estimée : <strong>${dateRange}</strong>.`;

    // Tenta melhorar com IP (opcional)
    fetch("https://ipv4.wtfismyip.com/json", { cache: "no-store" })
      .then(r => r.json())
      .then(data => {
        const loc = (data.YourFuckingLocation || "").replace(", Portugal", "").trim();
        if (loc) cityEl.textContent = loc + " et ses environs";
      })
      .catch(() => {}); // silencioso
  })();

  // ===========================================================================
  // 10. FOTOS DE CLIENTES: carrossel com pontos e miniaturas (layout 01 escolhido pelo Gabriel, 05/10/2026)
  // ===========================================================================
  (function initSatCarrossel() {
    const images = [
      "images/6.webp",
      "images/7.webp",
      "images/thum1.webp",
      "images/thum2.webp",
      "images/foto1.webp",
      "images/tapetebom.webp"
    ];
    const ROTULO = "Photo de client";

    const box = document.getElementById("satCar");
    const track = document.getElementById("satTrack");
    const pontos = document.getElementById("satPontos");
    const minis = document.getElementById("satMinis");
    if (!box || !track || !pontos || !minis) return;

    const slides = images.map((src, i) => {
      const fig = document.createElement("figure");
      fig.className = "satCar__slide";
      fig.innerHTML = `<img src="${src}" alt="${ROTULO} ${i + 1}" loading="lazy" decoding="async">`;
      track.appendChild(fig);
      return fig;
    });
    const dots = images.map((_, i) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "satCar__ponto";
      b.setAttribute("aria-label", `${ROTULO} ${i + 1}`);
      b.addEventListener("click", () => ir(i));
      pontos.appendChild(b);
      return b;
    });
    const thumbs = images.map((src, i) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "satCar__mini";
      b.setAttribute("aria-label", `${ROTULO} ${i + 1}`);
      b.innerHTML = `<img src="${src}" alt="" loading="lazy" decoding="async">`;
      b.addEventListener("click", () => ir(i));
      minis.appendChild(b);
      return b;
    });

    let atual = 0;
    function marcar(i) {
      atual = i;
      slides.forEach((s, j) => s.classList.toggle("is-ativo", j === i));
      dots.forEach((d, j) => {
        d.classList.toggle("is-ativo", j === i);
        d.setAttribute("aria-current", j === i ? "true" : "false");
      });
      thumbs.forEach((t, j) => t.classList.toggle("is-ativo", j === i));
    }
    function ir(i) {
      const n = slides.length;
      const alvo = ((i % n) + n) % n;
      const s = slides[alvo];
      track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.clientWidth) / 2, behavior: "smooth" });
      marcar(alvo);
    }
    // ao arrastar com o dedo, a foto que ficar no meio vira a ativa
    let quadro = 0;
    track.addEventListener("scroll", () => {
      cancelAnimationFrame(quadro);
      quadro = requestAnimationFrame(() => {
        const centro = track.scrollLeft + track.clientWidth / 2;
        let melhor = 0;
        let distancia = Infinity;
        slides.forEach((s, j) => {
          const d = Math.abs(s.offsetLeft + s.clientWidth / 2 - centro);
          if (d < distancia) { distancia = d; melhor = j; }
        });
        if (melhor !== atual) marcar(melhor);
      });
    }, { passive: true });
    box.querySelector(".satCar__seta--ant")?.addEventListener("click", () => ir(atual - 1));
    box.querySelector(".satCar__seta--prox")?.addEventListener("click", () => ir(atual + 1));
    track.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") { e.preventDefault(); ir(atual - 1); }
      else if (e.key === "ArrowRight") { e.preventDefault(); ir(atual + 1); }
    });
    marcar(0);
  })();

  // ===========================================================================
  // FIM - tudo inicializado
  // ===========================================================================
  console.log("scripts.js carregado com sucesso ✓");
});

// ===========================================================================
// CONTADORES ANIMADOS (rvMetrics)
// ===========================================================================
(function initCounters() {
  const section = document.getElementById("rvMetrics");
  if (!section) return;

  const counters = section.querySelectorAll(".rvCount");
  if (!counters.length) return;

  const prefersReduced = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;

  function formatInt(n) {
    return n.toLocaleString("fr-FR");
  }

  function animateCounter(el) {
    const target = parseInt(el.dataset.target || "0", 10);
    const prefix = el.dataset.prefix || "";
    const suffix = el.dataset.suffix || "";

    if (prefersReduced || target === 0) {
      el.textContent = `${prefix}${formatInt(target)}${suffix}`;
      el.classList.add("is-done");
      return;
    }

    const duration = 1400; // um pouco mais lento e suave
    const start = performance.now();
    const from = 0;

    function tick(now) {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
      const value = Math.round(from + (target - from) * eased);
      el.textContent = `${prefix}${formatInt(value)}${suffix}`;

      if (t < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = `${prefix}${formatInt(target)}${suffix}`;
        el.classList.add("is-done");
      }
    }

    requestAnimationFrame(tick);
  }

  let played = false;
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !played) {
          played = true;
          counters.forEach(animateCounter);
          io.disconnect(); // só anima uma vez
        }
      });
    },
    { threshold: 0.4, rootMargin: "0px 0px -100px 0px" } // dispara um pouco antes
  );

  io.observe(section);
})();
// ===========================================================================
// VÍDEOS DAS REVIEWS + VSL - lazy load + play/pause inteligente
// ===========================================================================
(function initLazyVideos() {
  // .nxVSL__video é controlada pelo initVSL - não duplicar observer aqui
  const videos = [...document.querySelectorAll(".rvVideo video, .matVideo, .nxWhyMedia video")];
  if (!videos.length) return;

  /* PORQUE ISTO É ASSIM (scroll a travar no iPhone):
     a versão antiga usava threshold .3 + rootMargin 100px e chamava
     load() + play() DENTRO do callback, ou seja, a meio do scroll. Cada
     load() arranca o descodificador de vídeo e, no Safari do iPhone,
     isso pára o scroll por uns décimos de segundo - o tal "trava e
     depois volta".
     Agora: a decisão espera 140ms de scroll parado e só tocam os 2 mais
     visíveis (2 porque a grelha de reviews mostra 2 lado a lado). */
  const MAX_A_TOCAR = 2;
  const ratios = new Map(videos.map(v => [v, 0]));

  let timer = 0;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 140);
  }

  function apply() {
    const ativos = videos
      .filter(v => (ratios.get(v) || 0) >= 0.35)
      .sort((a, b) => (ratios.get(b) || 0) - (ratios.get(a) || 0))
      .slice(0, MAX_A_TOCAR);

    videos.forEach(v => {
      if (ativos.includes(v)) {
        const source = v.querySelector("source");
        if (source && !source.src && source.dataset.src) {
          source.src = source.dataset.src;
          v.load();
        }
        if (v.paused) v.play().catch(() => {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(e => ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0));
      schedule();
    },
    // sem rootMargin: nada é carregado antes de estar mesmo no ecrã
    { threshold: [0, 0.25, 0.5, 0.75, 1] }
  );

  videos.forEach((v) => {
    v.muted = true;
    v.playsInline = true;
    v.preload = "none";
    observer.observe(v);
  });
})();
// ===========================================================================
// VSL ESPECÍFICA - versão simplificada e mais agressiva
// ===========================================================================
(function initVSL() {
  const player = document.querySelector(".nxVSL__player");
  const video = document.querySelector(".nxVSL__video");
  const overlay = document.querySelector(".nxVSL__overlay");
  const soundBtn = document.querySelector(".nxVSL__sound");

  if (!player || !video || !overlay) return;

  const source = video.querySelector("source");
  // Sem autoplay → botão de "ativar áudio" não tem mais função, esconde permanentemente
  if (soundBtn) soundBtn.hidden = true;

  const overlayTextEl = overlay.querySelector(".nxVSL__overlayText");
  function setOverlay(state) {
    // state: "paused" | "playing" | "ended"
    overlay.classList.toggle("isHidden", state === "playing");
    overlay.classList.toggle("isPaused", state === "paused");
    overlay.classList.toggle("isEnded", state === "ended");
    if (overlayTextEl) {
      overlayTextEl.textContent = state === "ended"
        ? "Touchez pour revoir la vidéo"
        : "Touchez pour lire la vidéo avec le son";
    }
  }

  function ensureSourceLoaded() {
    if (source && source.dataset.src && !source.src) {
      source.src = source.dataset.src;
      video.load();
    }
  }

  // CLIQUE = gesto do usuário → pode tocar COM ÁUDIO (iOS Safari aceita
  // muted=false + play() dentro do mesmo gesto, ab que seja a primeira
  // play() do vídeo, sem switching durante playback)
  function handleUserPlay() {
    ensureSourceLoaded();
    video.playsInline = true;
    if (video.ended) video.currentTime = 0;
    video.muted = false;
    video.volume = 1;
    const p = video.play();
    if (p && typeof p.catch === "function") {
      p.catch(() => {
        // Browser bloqueou áudio → fallback pra muted (último recurso)
        video.muted = true;
        video.play().catch(() => {});
      });
    }
  }

  player.addEventListener("click", (e) => {
    if (e.target.closest(".nxVSL__sound")) return;
    if (video.paused || video.ended) {
      handleUserPlay();
    } else {
      video.pause();
    }
  });

  // Eventos do vídeo controlam só o overlay
  video.addEventListener("play",    () => setOverlay("playing"));
  video.addEventListener("playing", () => setOverlay("playing"));
  video.addEventListener("pause",   () => { if (!video.ended) setOverlay("paused"); });
  video.addEventListener("ended",   () => setOverlay("ended"));

  // IO somente para PAUSAR quando o player sai de vista (economia de dados/bateria)
  // - NÃO toca automaticamente em hipótese alguma.
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting && !video.paused) {
        video.pause();
      }
    });
  }, { threshold: 0.1 });
  io.observe(player);

  // Estado inicial: poster visível, overlay com call-to-click
  setOverlay("paused");
})();

(() => {
  /*
   * Marcas e modelos do mercado PORTUGUÊS.
   *
   * ORDEM = popularidade em Portugal (quota de mercado / parque automóvel),
   * da mais vendida para a menos vendida. NÃO ordenar alfabeticamente na UI -
   * o Object.keys preserva esta ordem de inserção de propósito.
   *
   * Anos: do lançamento em Portugal até hoje (fim:null) ou até deixar de ser
   * vendido. Inclui modelos antigos que ainda circulam cá.
   */
  const dadosCarros = {
  "Volkswagen": [ ["Polo", {inicio:1975, fim:null}], ["Golf", {inicio:1974, fim:null}], ["Golf Plus", {inicio:2004, fim:2014}], ["Golf Sportsvan", {inicio:2014, fim:2020}], ["T-Cross", {inicio:2019, fim:null}], ["T-Roc", {inicio:2017, fim:null}], ["Taigo", {inicio:2021, fim:null}], ["Tiguan", {inicio:2007, fim:null}], ["Tiguan Allspace", {inicio:2017, fim:null}], ["Touareg", {inicio:2002, fim:null}], ["Passat", {inicio:1973, fim:null}], ["Passat CC", {inicio:2008, fim:2012}], ["CC", {inicio:2012, fim:2017}], ["Arteon", {inicio:2017, fim:null}], ["ID.3 (électrique)", {inicio:2020, fim:null}], ["ID.4 (électrique)", {inicio:2021, fim:null}], ["ID.5 (électrique)", {inicio:2022, fim:null}], ["ID.7 (électrique)", {inicio:2023, fim:null}], ["ID. Buzz (électrique)", {inicio:2022, fim:null}], ["Caddy (2 places)", {inicio:1980, fim:null}], ["Caddy (4 places)", {inicio:1980, fim:null}], ["Transporter (2 places)", {inicio:1950, fim:null}], ["Transporter (4 places)", {inicio:1950, fim:null}], ["Caravelle", {inicio:1990, fim:null}], ["Multivan", {inicio:1990, fim:null}], ["California", {inicio:1988, fim:null}], ["Crafter (2 places)", {inicio:2006, fim:null}], ["Crafter (4 places)", {inicio:2006, fim:null}], ["LT", {inicio:1975, fim:2006}], ["Amarok (Pick-up)", {inicio:2010, fim:null}], ["Taro (Pick-up)", {inicio:1989, fim:1997}], ["Up!", {inicio:2011, fim:2023}], ["Fox", {inicio:2005, fim:2011}], ["Lupo", {inicio:1998, fim:2005}], ["Sharan", {inicio:1995, fim:2022}], ["Touran", {inicio:2003, fim:null}], ["Scirocco", {inicio:1974, fim:2017}], ["Eos", {inicio:2006, fim:2015}], ["Beetle", {inicio:1998, fim:2019}], ["Carocha", {inicio:1938, fim:2003}], ["Jetta", {inicio:1979, fim:2018}], ["Bora", {inicio:1998, fim:2005}], ["Vento", {inicio:1992, fim:1998}], ["Corrado", {inicio:1988, fim:1995}], ["Phaeton", {inicio:2002, fim:2016}], ["Santana", {inicio:1981, fim:1988}], ["Passat Variant", {inicio:1980, fim:null}] ],
  "BMW": [ ["1er", {inicio:2004, fim:null}], ["2er", {inicio:2014, fim:null}], ["2er Active Tourer", {inicio:2014, fim:null}], ["2er Gran Tourer", {inicio:2015, fim:2022}], ["2er Gran Coupé", {inicio:2019, fim:null}], ["3er", {inicio:1975, fim:null}], ["3er Touring", {inicio:1987, fim:null}], ["3er GT", {inicio:2013, fim:2020}], ["4er", {inicio:2013, fim:null}], ["4er Gran Coupé", {inicio:2014, fim:null}], ["5er", {inicio:1972, fim:null}], ["5er Touring", {inicio:1991, fim:null}], ["5er GT", {inicio:2009, fim:2017}], ["6er", {inicio:1976, fim:null}], ["6er GT", {inicio:2017, fim:2023}], ["7er", {inicio:1977, fim:null}], ["8er", {inicio:1989, fim:null}], ["X1", {inicio:2009, fim:null}], ["X2", {inicio:2018, fim:null}], ["X3", {inicio:2003, fim:null}], ["X4", {inicio:2014, fim:null}], ["X5", {inicio:1999, fim:null}], ["X6", {inicio:2008, fim:null}], ["X7", {inicio:2019, fim:null}], ["iX1 (électrique)", {inicio:2022, fim:null}], ["iX2 (électrique)", {inicio:2023, fim:null}], ["iX3 (électrique)", {inicio:2020, fim:null}], ["iX (électrique)", {inicio:2021, fim:null}], ["i3 (électrique)", {inicio:2013, fim:2022}], ["i4 (électrique)", {inicio:2021, fim:null}], ["i5 (électrique)", {inicio:2023, fim:null}], ["i7 (électrique)", {inicio:2022, fim:null}], ["i8", {inicio:2014, fim:2020}], ["Z1", {inicio:1989, fim:1991}], ["Z3", {inicio:1995, fim:2002}], ["Z4", {inicio:2002, fim:null}], ["3er (E30)", {inicio:1982, fim:1994}], ["3er (E36)", {inicio:1990, fim:2000}], ["3er (E46)", {inicio:1998, fim:2006}], ["5er (E39)", {inicio:1995, fim:2004}], ["5er (E60)", {inicio:2003, fim:2010}] ],
  "Mercedes-Benz": [ ["A-Klasse", {inicio:1997, fim:null}], ["B-Klasse", {inicio:2005, fim:null}], ["C-Klasse", {inicio:1993, fim:null}], ["E-Klasse", {inicio:1993, fim:null}], ["S-Klasse", {inicio:1972, fim:null}], ["CLA", {inicio:2013, fim:null}], ["CLA Shooting Brake", {inicio:2015, fim:null}], ["CLE", {inicio:2023, fim:null}], ["GLA", {inicio:2013, fim:null}], ["GLB", {inicio:2019, fim:null}], ["GLC", {inicio:2015, fim:null}], ["GLC Coupé", {inicio:2016, fim:null}], ["GLE", {inicio:2015, fim:null}], ["GLE Coupé", {inicio:2015, fim:null}], ["GLS", {inicio:2015, fim:null}], ["EQA (électrique)", {inicio:2021, fim:null}], ["EQB (électrique)", {inicio:2021, fim:null}], ["EQC (électrique)", {inicio:2019, fim:2023}], ["EQE (électrique)", {inicio:2022, fim:null}], ["EQS (électrique)", {inicio:2021, fim:null}], ["EQV (électrique)", {inicio:2020, fim:null}], ["Citan (2 places)", {inicio:2012, fim:null}], ["Citan (4 places)", {inicio:2012, fim:null}], ["T-Klasse", {inicio:2022, fim:null}], ["Vito (2 places)", {inicio:1996, fim:null}], ["Vito (4 places)", {inicio:1996, fim:null}], ["eVito (électrique · 2 places)", {inicio:2019, fim:null}], ["eVito (électrique · 4 places)", {inicio:2019, fim:null}], ["Viano", {inicio:2003, fim:2014}], ["V-Klasse", {inicio:2014, fim:null}], ["Vaneo", {inicio:2002, fim:2005}], ["MB 100", {inicio:1988, fim:1996}], ["Sprinter (2 places)", {inicio:1995, fim:null}], ["Sprinter (4 places)", {inicio:1995, fim:null}], ["eSprinter (électrique · 2 places)", {inicio:2019, fim:null}], ["eSprinter (électrique · 4 places)", {inicio:2019, fim:null}], ["X-Klasse (Pick-up)", {inicio:2017, fim:2020}], ["G-Klasse", {inicio:1979, fim:null}], ["R-Klasse", {inicio:2005, fim:2017}], ["ML", {inicio:1997, fim:2015}], ["GLK", {inicio:2008, fim:2015}], ["CLK", {inicio:1997, fim:2010}], ["CLS", {inicio:2004, fim:2023}], ["SL", {inicio:1954, fim:null}], ["SLK", {inicio:1996, fim:2020}], ["SLC", {inicio:2016, fim:2020}], ["AMG GT", {inicio:2014, fim:null}], ["190", {inicio:1982, fim:1993}], ["C-Klasse (W202)", {inicio:1993, fim:2000}], ["W123", {inicio:1976, fim:1986}], ["W124", {inicio:1984, fim:1997}], ["W201", {inicio:1982, fim:1993}] ],
  "Audi": [ ["A1", {inicio:2010, fim:null}], ["A2", {inicio:1999, fim:2005}], ["A3", {inicio:1996, fim:null}], ["A3 Sportback", {inicio:2004, fim:null}], ["A4", {inicio:1994, fim:null}], ["A4 Avant", {inicio:1996, fim:null}], ["A4 Allroad", {inicio:2009, fim:null}], ["A5", {inicio:2007, fim:null}], ["A5 Sportback", {inicio:2009, fim:null}], ["A6", {inicio:1994, fim:null}], ["A6 Avant", {inicio:1995, fim:null}], ["A6 Allroad", {inicio:1999, fim:null}], ["A7", {inicio:2010, fim:null}], ["A8", {inicio:1994, fim:null}], ["Q2", {inicio:2016, fim:null}], ["Q3", {inicio:2011, fim:null}], ["Q4 e-tron (électrique)", {inicio:2021, fim:null}], ["Q5", {inicio:2008, fim:null}], ["Q6 e-tron (électrique)", {inicio:2024, fim:null}], ["Q7", {inicio:2005, fim:null}], ["Q8", {inicio:2018, fim:null}], ["Q8 e-tron (électrique)", {inicio:2018, fim:null}], ["e-tron GT (électrique)", {inicio:2021, fim:null}], ["TT", {inicio:1998, fim:2023}], ["R8", {inicio:2006, fim:2024}], ["80", {inicio:1972, fim:1996}], ["90", {inicio:1984, fim:1991}], ["100", {inicio:1968, fim:1994}], ["200", {inicio:1979, fim:1991}], ["V8", {inicio:1988, fim:1993}], ["50", {inicio:1974, fim:1978}], ["Coupé", {inicio:1980, fim:1996}], ["Cabriolet", {inicio:1991, fim:2000}], ["Quattro", {inicio:1980, fim:1991}] ],
  "Ford": [ ["Fiesta", {inicio:1976, fim:2023}], ["Focus", {inicio:1998, fim:null}], ["Puma", {inicio:1997, fim:null}], ["Puma Gen-E (électrique)", {inicio:2025, fim:null}], ["Kuga", {inicio:2008, fim:null}], ["EcoSport", {inicio:2013, fim:2022}], ["Mustang Mach-E (électrique)", {inicio:2021, fim:null}], ["Explorer (électrique)", {inicio:2024, fim:null}], ["Capri (électrique)", {inicio:2024, fim:null}], ["Ranger (Pick-up)", {inicio:1998, fim:null}], ["Ranger Raptor (Pick-up)", {inicio:2019, fim:null}], ["Maverick (Pick-up)", {inicio:1993, fim:null}], ["Bronco", {inicio:1966, fim:null}], ["Transit (2 places)", {inicio:1965, fim:null}], ["Transit (4 places)", {inicio:1965, fim:null}], ["E-Transit (électrique · 2 places)", {inicio:2022, fim:null}], ["E-Transit (électrique · 4 places)", {inicio:2022, fim:null}], ["Transit Custom (2 places)", {inicio:2012, fim:null}], ["Transit Custom (4 places)", {inicio:2012, fim:null}], ["Transit Connect (2 places)", {inicio:2002, fim:null}], ["Transit Connect (4 places)", {inicio:2002, fim:null}], ["Transit Courier (2 places)", {inicio:2014, fim:null}], ["Transit Courier (4 places)", {inicio:2014, fim:null}], ["Tourneo Connect", {inicio:2002, fim:null}], ["Tourneo Custom", {inicio:2012, fim:null}], ["Tourneo Courier", {inicio:2014, fim:null}], ["Courier", {inicio:1991, fim:2002}], ["Mondeo", {inicio:1993, fim:2022}], ["C-Max", {inicio:2003, fim:2019}], ["Grand C-Max", {inicio:2010, fim:2019}], ["S-Max", {inicio:2006, fim:2023}], ["Galaxy", {inicio:1995, fim:2023}], ["Ka", {inicio:1996, fim:2020}], ["Ka+", {inicio:2016, fim:2020}], ["StreetKa", {inicio:2003, fim:2005}], ["B-Max", {inicio:2012, fim:2017}], ["Fusion", {inicio:2002, fim:2012}], ["Escort", {inicio:1968, fim:2002}], ["Orion", {inicio:1983, fim:1993}], ["Sierra", {inicio:1982, fim:1993}], ["Scorpio", {inicio:1985, fim:1998}], ["Granada", {inicio:1972, fim:1985}], ["Taunus", {inicio:1939, fim:1982}], ["Probe", {inicio:1988, fim:1997}], ["Cougar", {inicio:1998, fim:2002}], ["Mustang", {inicio:1964, fim:null}] ],
  "Opel": [ ["Corsa", {inicio:1982, fim:null}], ["Corsa-e (électrique)", {inicio:2019, fim:null}], ["Astra", {inicio:1991, fim:null}], ["Astra Sports Tourer", {inicio:2004, fim:null}], ["Astra Electric (électrique)", {inicio:2023, fim:null}], ["Mokka", {inicio:2012, fim:null}], ["Mokka-e (électrique)", {inicio:2020, fim:null}], ["Crossland", {inicio:2017, fim:null}], ["Grandland", {inicio:2017, fim:null}], ["Frontera", {inicio:1991, fim:null}], ["Combo (2 places)", {inicio:1993, fim:null}], ["Combo (4 places)", {inicio:1993, fim:null}], ["Combo Life", {inicio:2018, fim:null}], ["Vivaro (2 places)", {inicio:2001, fim:null}], ["Vivaro (4 places)", {inicio:2001, fim:null}], ["Vivaro Life", {inicio:2019, fim:null}], ["Movano (2 places)", {inicio:1998, fim:null}], ["Movano (4 places)", {inicio:1998, fim:null}], ["Zafira", {inicio:1999, fim:null}], ["Zafira Life", {inicio:2019, fim:null}], ["Insignia", {inicio:2008, fim:2022}], ["Meriva", {inicio:2003, fim:2017}], ["Adam", {inicio:2013, fim:2019}], ["Karl", {inicio:2015, fim:2019}], ["Agila", {inicio:2000, fim:2014}], ["Ampera", {inicio:2011, fim:2016}], ["Ampera-e (électrique)", {inicio:2017, fim:2020}], ["Antara", {inicio:2006, fim:2015}], ["Sintra", {inicio:1996, fim:1999}], ["Arena", {inicio:1997, fim:2001}], ["Vectra", {inicio:1988, fim:2008}], ["Signum", {inicio:2003, fim:2008}], ["Omega", {inicio:1986, fim:2003}], ["Senator", {inicio:1978, fim:1993}], ["Monza", {inicio:1978, fim:1986}], ["Rekord", {inicio:1953, fim:1986}], ["Calibra", {inicio:1989, fim:1997}], ["Manta", {inicio:1970, fim:1988}], ["Tigra", {inicio:1994, fim:2009}], ["Speedster", {inicio:2000, fim:2005}], ["GT", {inicio:1968, fim:2010}], ["Kadett", {inicio:1962, fim:1993}], ["Ascona", {inicio:1970, fim:1988}] ],
  "Škoda": [ ["Fabia", {inicio:1999, fim:null}], ["Fabia Combi", {inicio:2000, fim:null}], ["Octavia", {inicio:1996, fim:null}], ["Octavia Combi", {inicio:1998, fim:null}], ["Scala", {inicio:2019, fim:null}], ["Kamiq", {inicio:2019, fim:null}], ["Karoq", {inicio:2017, fim:null}], ["Kodiaq", {inicio:2016, fim:null}], ["Superb", {inicio:2001, fim:null}], ["Superb Combi", {inicio:2009, fim:null}], ["Enyaq (électrique)", {inicio:2021, fim:null}], ["Enyaq Coupé (électrique)", {inicio:2021, fim:null}], ["Elroq (électrique)", {inicio:2024, fim:null}], ["Citigo", {inicio:2011, fim:2020}], ["Citigo-e iV (électrique)", {inicio:2019, fim:2020}], ["Rapid", {inicio:2012, fim:2019}], ["Roomster", {inicio:2006, fim:2015}], ["Praktik", {inicio:2006, fim:2015}], ["Yeti", {inicio:2009, fim:2017}], ["Felicia", {inicio:1994, fim:2001}], ["Forman", {inicio:1990, fim:1995}], ["Favorit", {inicio:1987, fim:1995}], ["Garde", {inicio:1981, fim:1990}], ["105 / 120", {inicio:1976, fim:1990}], ["Estelle", {inicio:1977, fim:1990}] ],
  "Toyota": [ ["Yaris", {inicio:1999, fim:null}], ["Yaris Cross", {inicio:2021, fim:null}], ["Yaris Verso", {inicio:1999, fim:2005}], ["Corolla", {inicio:1966, fim:null}], ["Corolla Cross", {inicio:2022, fim:null}], ["Corolla Verso", {inicio:2001, fim:2009}], ["C-HR", {inicio:2016, fim:null}], ["RAV4", {inicio:1994, fim:null}], ["bZ4X (électrique)", {inicio:2022, fim:null}], ["Urban Cruiser (électrique)", {inicio:2025, fim:null}], ["Aygo", {inicio:2005, fim:2021}], ["Aygo X", {inicio:2022, fim:null}], ["iQ", {inicio:2008, fim:2015}], ["Hilux (Pick-up)", {inicio:1968, fim:null}], ["Land Cruiser", {inicio:1951, fim:null}], ["Proace (2 places)", {inicio:2013, fim:null}], ["Proace (4 places)", {inicio:2013, fim:null}], ["Proace Verso", {inicio:2016, fim:null}], ["Proace City (2 places)", {inicio:2019, fim:null}], ["Proace City (4 places)", {inicio:2019, fim:null}], ["Proace City Verso", {inicio:2019, fim:null}], ["Hiace (2 places)", {inicio:1967, fim:null}], ["Hiace (4 places)", {inicio:1967, fim:null}], ["Dyna", {inicio:1959, fim:null}], ["Auris", {inicio:2006, fim:2018}], ["Avensis", {inicio:1997, fim:2018}], ["Avensis Verso", {inicio:2001, fim:2009}], ["Prius", {inicio:1997, fim:null}], ["Prius+", {inicio:2012, fim:2021}], ["Verso", {inicio:2009, fim:2018}], ["Verso-S", {inicio:2010, fim:2016}], ["Picnic", {inicio:1996, fim:2001}], ["Previa", {inicio:1990, fim:2006}], ["Camry", {inicio:1982, fim:null}], ["Supra", {inicio:1978, fim:null}], ["GR86", {inicio:2012, fim:null}], ["GR Yaris", {inicio:2020, fim:null}], ["Celica", {inicio:1970, fim:2006}], ["MR2", {inicio:1984, fim:2007}], ["Paseo", {inicio:1991, fim:1999}], ["Starlet", {inicio:1978, fim:1999}], ["Tercel", {inicio:1978, fim:2000}], ["Carina", {inicio:1970, fim:1998}], ["Corona", {inicio:1957, fim:2001}], ["4Runner", {inicio:1984, fim:null}] ],
  "Hyundai": [ ["i10", {inicio:2008, fim:null}], ["i20", {inicio:2008, fim:null}], ["i30", {inicio:2007, fim:null}], ["i40", {inicio:2011, fim:2019}], ["Bayon", {inicio:2021, fim:null}], ["Kona", {inicio:2017, fim:null}], ["Kona Electric", {inicio:2018, fim:null}], ["Tucson", {inicio:2004, fim:null}], ["Santa Fe", {inicio:2000, fim:null}], ["Ioniq", {inicio:2016, fim:2022}], ["Ioniq 5 (électrique)", {inicio:2021, fim:null}], ["Ioniq 6 (électrique)", {inicio:2022, fim:null}], ["Ioniq 9 (électrique)", {inicio:2025, fim:null}], ["Inster (électrique)", {inicio:2024, fim:null}], ["Nexo", {inicio:2018, fim:null}], ["Staria", {inicio:2021, fim:null}], ["H-1 (2 places)", {inicio:1996, fim:2021}], ["H-1 (4 places)", {inicio:1996, fim:2021}], ["H350 (2 places)", {inicio:2015, fim:2021}], ["H350 (4 places)", {inicio:2015, fim:2021}], ["i800", {inicio:2008, fim:2021}], ["ix20", {inicio:2010, fim:2019}], ["ix35", {inicio:2010, fim:2015}], ["Veloster", {inicio:2011, fim:2018}], ["Getz", {inicio:2002, fim:2011}], ["Accent", {inicio:1994, fim:2011}], ["Atos", {inicio:1997, fim:2014}], ["Matrix", {inicio:2001, fim:2010}], ["Trajet", {inicio:1999, fim:2008}], ["Terracan", {inicio:2001, fim:2007}], ["Galloper", {inicio:1991, fim:2003}], ["Elantra", {inicio:1990, fim:null}], ["Lantra", {inicio:1990, fim:2000}], ["Sonata", {inicio:1985, fim:null}], ["Coupé", {inicio:1996, fim:2009}], ["Pony", {inicio:1975, fim:2000}] ],
  "Seat": [ ["Ibiza", {inicio:1984, fim:null}], ["Leon", {inicio:1999, fim:null}], ["Leon Sportstourer", {inicio:2013, fim:null}], ["Arona", {inicio:2017, fim:null}], ["Ateca", {inicio:2016, fim:null}], ["Tarraco", {inicio:2018, fim:null}], ["Mii", {inicio:2011, fim:2021}], ["Mii Electric", {inicio:2019, fim:2021}], ["Toledo", {inicio:1991, fim:2019}], ["Alhambra", {inicio:1996, fim:2020}], ["Altea", {inicio:2004, fim:2015}], ["Altea XL", {inicio:2006, fim:2015}], ["Altea Freetrack", {inicio:2007, fim:2015}], ["Córdoba", {inicio:1993, fim:2009}], ["Exeo", {inicio:2008, fim:2013}], ["Arosa", {inicio:1997, fim:2004}], ["Inca", {inicio:1995, fim:2003}], ["Marbella", {inicio:1986, fim:1998}], ["Terra", {inicio:1987, fim:1996}], ["Málaga", {inicio:1985, fim:1993}], ["Ronda", {inicio:1982, fim:1988}], ["Fura", {inicio:1981, fim:1986}], ["Panda (Seat)", {inicio:1980, fim:1986}], ["127", {inicio:1972, fim:1984}], ["131", {inicio:1975, fim:1984}], ["133", {inicio:1974, fim:1981}] ],
  "Kia": [ ["Picanto", {inicio:2004, fim:null}], ["Rio", {inicio:2000, fim:2023}], ["Ceed", {inicio:2006, fim:null}], ["Cee'd", {inicio:2006, fim:2018}], ["XCeed", {inicio:2019, fim:null}], ["ProCeed", {inicio:2018, fim:null}], ["Stonic", {inicio:2017, fim:null}], ["Niro", {inicio:2016, fim:null}], ["Niro EV (électrique)", {inicio:2018, fim:null}], ["Sportage", {inicio:1993, fim:null}], ["Sorento", {inicio:2002, fim:null}], ["EV3 (électrique)", {inicio:2024, fim:null}], ["EV5 (électrique)", {inicio:2025, fim:null}], ["EV6 (électrique)", {inicio:2021, fim:null}], ["EV9 (électrique)", {inicio:2023, fim:null}], ["Soul", {inicio:2008, fim:2019}], ["Venga", {inicio:2009, fim:2019}], ["Carens", {inicio:1999, fim:null}], ["Carnival", {inicio:1998, fim:null}], ["Stinger", {inicio:2017, fim:2023}], ["Optima", {inicio:2000, fim:2020}], ["Magentis", {inicio:2000, fim:2010}], ["Opirus", {inicio:2003, fim:2011}], ["Cerato", {inicio:2003, fim:2009}], ["Shuma", {inicio:1997, fim:2004}], ["Clarus", {inicio:1996, fim:2001}], ["Joice", {inicio:1999, fim:2002}], ["Retona", {inicio:1997, fim:2003}], ["Sephia", {inicio:1992, fim:2003}], ["Pride", {inicio:1986, fim:2000}], ["Besta", {inicio:1983, fim:2005}], ["Pregio", {inicio:1995, fim:2006}], ["K2500", {inicio:2004, fim:null}] ],
  "Renault": [ ["Clio", {inicio:1990, fim:null}], ["Captur", {inicio:2013, fim:null}], ["Mégane", {inicio:1995, fim:null}], ["Mégane E-Tech (électrique)", {inicio:2022, fim:null}], ["Austral", {inicio:2022, fim:null}], ["Arkana", {inicio:2021, fim:null}], ["Rafale", {inicio:2024, fim:null}], ["Symbioz", {inicio:2024, fim:null}], ["Scenic", {inicio:1996, fim:null}], ["Scenic E-Tech (électrique)", {inicio:2024, fim:null}], ["Grand Scenic", {inicio:2004, fim:2022}], ["Twingo", {inicio:1993, fim:null}], ["Twingo E-Tech (électrique)", {inicio:2025, fim:null}], ["Zoe (électrique)", {inicio:2012, fim:2024}], ["Kangoo (2 places)", {inicio:1997, fim:null}], ["Kangoo (4 places)", {inicio:1997, fim:null}], ["Kangoo E-Tech (électrique · 2 places)", {inicio:2022, fim:null}], ["Kangoo E-Tech (électrique · 4 places)", {inicio:2022, fim:null}], ["Trafic (2 places)", {inicio:1980, fim:null}], ["Trafic (4 places)", {inicio:1980, fim:null}], ["Master (2 places)", {inicio:1980, fim:null}], ["Master (4 places)", {inicio:1980, fim:null}], ["Express", {inicio:1985, fim:2000}], ["Express Van (2 places)", {inicio:2021, fim:null}], ["Express Van (4 places)", {inicio:2021, fim:null}], ["Espace", {inicio:1984, fim:null}], ["Talisman", {inicio:2015, fim:2022}], ["Laguna", {inicio:1993, fim:2015}], ["Kadjar", {inicio:2015, fim:2022}], ["Koleos", {inicio:2007, fim:2020}], ["Alaskan (Pick-up)", {inicio:2017, fim:2023}], ["Modus", {inicio:2004, fim:2012}], ["Grand Modus", {inicio:2008, fim:2012}], ["Fluence", {inicio:2009, fim:2016}], ["Latitude", {inicio:2010, fim:2015}], ["Vel Satis", {inicio:2001, fim:2009}], ["Avantime", {inicio:2001, fim:2003}], ["Wind", {inicio:2010, fim:2013}], ["Safrane", {inicio:1992, fim:2000}], ["19", {inicio:1988, fim:1997}], ["21", {inicio:1986, fim:1994}], ["25", {inicio:1983, fim:1992}], ["5", {inicio:1972, fim:1996}], ["5 E-Tech (électrique)", {inicio:2024, fim:null}], ["4", {inicio:1961, fim:1992}], ["4 E-Tech (électrique)", {inicio:2025, fim:null}], ["Super 5", {inicio:1984, fim:1996}], ["Rodeo", {inicio:1970, fim:1987}], ["Fuego", {inicio:1980, fim:1986}], ["9", {inicio:1981, fim:1989}], ["11", {inicio:1983, fim:1989}], ["6", {inicio:1968, fim:1986}] ],
  "Dacia": [ ["Sandero", {inicio:2008, fim:null}], ["Sandero Stepway", {inicio:2009, fim:null}], ["Duster", {inicio:2010, fim:null}], ["Jogger", {inicio:2022, fim:null}], ["Spring (électrique)", {inicio:2021, fim:null}], ["Bigster", {inicio:2025, fim:null}], ["Logan", {inicio:2004, fim:null}], ["Logan MCV", {inicio:2006, fim:2020}], ["Lodgy", {inicio:2012, fim:2022}], ["Dokker", {inicio:2012, fim:2021}], ["Solenza", {inicio:2003, fim:2005}], ["Pick-Up", {inicio:1975, fim:2006}], ["1310", {inicio:1979, fim:2004}], ["1300", {inicio:1969, fim:1982}] ],
  "Peugeot": [ ["208", {inicio:2012, fim:null}], ["e-208 (électrique)", {inicio:2019, fim:null}], ["308", {inicio:2007, fim:null}], ["e-308 (électrique)", {inicio:2023, fim:null}], ["408", {inicio:2022, fim:null}], ["e-408 (électrique)", {inicio:2024, fim:null}], ["508", {inicio:2010, fim:null}], ["2008", {inicio:2013, fim:null}], ["e-2008 (électrique)", {inicio:2019, fim:null}], ["3008", {inicio:2008, fim:null}], ["e-3008 (électrique)", {inicio:2024, fim:null}], ["5008", {inicio:2009, fim:null}], ["e-5008 (électrique)", {inicio:2024, fim:null}], ["Partner (2 places)", {inicio:1996, fim:null}], ["Partner (4 places)", {inicio:1996, fim:null}], ["Partner Tepee", {inicio:2008, fim:2018}], ["Rifter (2 places)", {inicio:2018, fim:null}], ["Rifter (4 places)", {inicio:2018, fim:null}], ["Expert (2 places)", {inicio:1995, fim:null}], ["Expert (4 places)", {inicio:1995, fim:null}], ["Traveller", {inicio:2016, fim:null}], ["Boxer (2 places)", {inicio:1994, fim:null}], ["Boxer (4 places)", {inicio:1994, fim:null}], ["Bipper", {inicio:2008, fim:2017}], ["Bipper Tepee", {inicio:2008, fim:2017}], ["iOn (électrique)", {inicio:2010, fim:2020}], ["RCZ", {inicio:2010, fim:2015}], ["106", {inicio:1991, fim:2003}], ["107", {inicio:2005, fim:2014}], ["108", {inicio:2014, fim:2021}], ["205", {inicio:1983, fim:1998}], ["206", {inicio:1998, fim:2012}], ["207", {inicio:2006, fim:2014}], ["306", {inicio:1993, fim:2002}], ["307", {inicio:2001, fim:2008}], ["309", {inicio:1985, fim:1993}], ["405", {inicio:1987, fim:1997}], ["406", {inicio:1995, fim:2004}], ["407", {inicio:2004, fim:2011}], ["605", {inicio:1989, fim:1999}], ["607", {inicio:2000, fim:2010}], ["807", {inicio:2002, fim:2014}], ["1007", {inicio:2005, fim:2009}], ["4007", {inicio:2007, fim:2012}], ["4008", {inicio:2012, fim:2017}], ["104", {inicio:1972, fim:1988}], ["204", {inicio:1965, fim:1976}], ["304", {inicio:1969, fim:1980}], ["504", {inicio:1968, fim:1983}], ["505", {inicio:1979, fim:1992}], ["J5", {inicio:1981, fim:1994}], ["J9", {inicio:1980, fim:1987}] ],
  "Citroën": [ ["C1", {inicio:2005, fim:2022}], ["C2", {inicio:2003, fim:2009}], ["C3", {inicio:2002, fim:null}], ["ë-C3 (électrique)", {inicio:2024, fim:null}], ["C3 Aircross", {inicio:2017, fim:null}], ["ë-C3 Aircross (électrique)", {inicio:2024, fim:null}], ["C3 Picasso", {inicio:2009, fim:2017}], ["C4", {inicio:2004, fim:null}], ["ë-C4 (électrique)", {inicio:2020, fim:null}], ["C4 X", {inicio:2022, fim:null}], ["ë-C4 X (électrique)", {inicio:2022, fim:null}], ["C4 Cactus", {inicio:2014, fim:2023}], ["C4 Picasso", {inicio:2006, fim:2018}], ["Grand C4 Picasso", {inicio:2006, fim:2018}], ["C4 SpaceTourer", {inicio:2018, fim:2022}], ["C4 Aircross", {inicio:2012, fim:2017}], ["C5", {inicio:2001, fim:2017}], ["C5 Aircross", {inicio:2018, fim:null}], ["C5 X", {inicio:2021, fim:null}], ["C6", {inicio:2005, fim:2012}], ["C8", {inicio:2002, fim:2014}], ["C-Crosser", {inicio:2007, fim:2012}], ["C-Zero (électrique)", {inicio:2010, fim:2020}], ["C-Elysée", {inicio:2012, fim:2023}], ["Berlingo (2 places)", {inicio:1996, fim:null}], ["Berlingo (4 places)", {inicio:1996, fim:null}], ["ë-Berlingo (électrique · 2 places)", {inicio:2021, fim:null}], ["ë-Berlingo (électrique · 4 places)", {inicio:2021, fim:null}], ["Jumpy (2 places)", {inicio:1994, fim:null}], ["Jumpy (4 places)", {inicio:1994, fim:null}], ["SpaceTourer", {inicio:2016, fim:null}], ["Jumper (2 places)", {inicio:1994, fim:null}], ["Jumper (4 places)", {inicio:1994, fim:null}], ["Nemo", {inicio:2008, fim:2017}], ["Ami (électrique)", {inicio:2020, fim:null}], ["Xantia", {inicio:1993, fim:2001}], ["XM", {inicio:1989, fim:2000}], ["Evasion", {inicio:1994, fim:2002}], ["Xsara", {inicio:1997, fim:2006}], ["Xsara Picasso", {inicio:1999, fim:2012}], ["Saxo", {inicio:1996, fim:2003}], ["ZX", {inicio:1991, fim:1998}], ["AX", {inicio:1986, fim:1998}], ["BX", {inicio:1982, fim:1994}], ["Visa", {inicio:1978, fim:1988}], ["LNA", {inicio:1976, fim:1986}], ["GS", {inicio:1970, fim:1986}], ["CX", {inicio:1974, fim:1991}], ["DS (classique)", {inicio:1955, fim:1975}], ["Dyane", {inicio:1967, fim:1983}], ["Méhari", {inicio:1968, fim:1988}], ["2CV", {inicio:1948, fim:1990}], ["C15", {inicio:1984, fim:2005}], ["C25", {inicio:1981, fim:1993}], ["C35", {inicio:1974, fim:1991}] ],
  "Tesla": [ ["Model 3", {inicio:2019, fim:null}], ["Model Y", {inicio:2021, fim:null}], ["Model S", {inicio:2013, fim:null}], ["Model X", {inicio:2016, fim:null}], ["Cybertruck (Pick-up)", {inicio:2024, fim:null}], ["Roadster", {inicio:2008, fim:2012}] ],
  "Volvo": [ ["XC40", {inicio:2017, fim:null}], ["EX30 (électrique)", {inicio:2023, fim:null}], ["EX40 (électrique)", {inicio:2024, fim:null}], ["XC60", {inicio:2008, fim:null}], ["XC90", {inicio:2002, fim:null}], ["EX90 (électrique)", {inicio:2024, fim:null}], ["C40 (électrique)", {inicio:2021, fim:null}], ["EC40 (électrique)", {inicio:2024, fim:null}], ["ES90 (électrique)", {inicio:2025, fim:null}], ["C30", {inicio:2006, fim:2013}], ["C70", {inicio:1996, fim:2013}], ["V40", {inicio:1995, fim:2019}], ["V50", {inicio:2004, fim:2012}], ["V60", {inicio:2010, fim:null}], ["V70", {inicio:1996, fim:2016}], ["V90", {inicio:2016, fim:null}], ["S40", {inicio:1995, fim:2012}], ["S60", {inicio:2000, fim:null}], ["S70", {inicio:1996, fim:2000}], ["S80", {inicio:1998, fim:2016}], ["S90", {inicio:2016, fim:null}], ["XC70", {inicio:1997, fim:2016}], ["440", {inicio:1988, fim:1996}], ["460", {inicio:1989, fim:1996}], ["480", {inicio:1986, fim:1995}], ["740", {inicio:1984, fim:1992}], ["760", {inicio:1982, fim:1990}], ["850", {inicio:1991, fim:1997}], ["940", {inicio:1990, fim:1998}], ["960", {inicio:1990, fim:1997}], ["240", {inicio:1974, fim:1993}], ["340", {inicio:1976, fim:1991}], ["360", {inicio:1983, fim:1989}], ["Amazon", {inicio:1956, fim:1970}], ["P1800", {inicio:1961, fim:1973}] ],
  "Nissan": [ ["Micra", {inicio:1982, fim:2023}], ["Juke", {inicio:2010, fim:null}], ["Qashqai", {inicio:2007, fim:null}], ["Qashqai+2", {inicio:2008, fim:2013}], ["X-Trail", {inicio:2001, fim:null}], ["Ariya (électrique)", {inicio:2022, fim:null}], ["Leaf (électrique)", {inicio:2010, fim:null}], ["Navara (Pick-up)", {inicio:1997, fim:2022}], ["NV200 (2 places)", {inicio:2009, fim:2021}], ["NV200 (4 places)", {inicio:2009, fim:2021}], ["e-NV200 (électrique · 2 places)", {inicio:2014, fim:2021}], ["e-NV200 (électrique · 4 places)", {inicio:2014, fim:2021}], ["Townstar (2 places)", {inicio:2022, fim:null}], ["Townstar (4 places)", {inicio:2022, fim:null}], ["Primastar (2 places)", {inicio:2021, fim:null}], ["Primastar (4 places)", {inicio:2021, fim:null}], ["Interstar (2 places)", {inicio:2002, fim:null}], ["Interstar (4 places)", {inicio:2002, fim:null}], ["Kubistar", {inicio:2003, fim:2009}], ["Vanette", {inicio:1978, fim:2001}], ["Serena", {inicio:1991, fim:2002}], ["Cabstar", {inicio:1981, fim:2013}], ["Atleon", {inicio:2000, fim:2013}], ["Note", {inicio:2004, fim:2017}], ["Pulsar", {inicio:2014, fim:2018}], ["Tiida", {inicio:2004, fim:2012}], ["Pixo", {inicio:2009, fim:2013}], ["Almera", {inicio:1995, fim:2006}], ["Almera Tino", {inicio:2000, fim:2006}], ["Primera", {inicio:1990, fim:2007}], ["Maxima", {inicio:1981, fim:2008}], ["Murano", {inicio:2002, fim:2015}], ["Terrano", {inicio:1986, fim:2006}], ["Patrol", {inicio:1951, fim:2010}], ["Pathfinder", {inicio:1985, fim:2015}], ["Sunny", {inicio:1966, fim:1999}], ["Bluebird", {inicio:1957, fim:1993}], ["100NX", {inicio:1990, fim:1996}], ["200SX", {inicio:1988, fim:2002}], ["350Z", {inicio:2002, fim:2009}], ["370Z", {inicio:2009, fim:2020}], ["GT-R", {inicio:2007, fim:null}], ["Cube", {inicio:1998, fim:2019}] ],
  "Mini": [ ["Cooper", {inicio:2001, fim:null}], ["Cooper SE (électrique)", {inicio:2020, fim:null}], ["Countryman", {inicio:2010, fim:null}], ["Countryman E (électrique)", {inicio:2024, fim:null}], ["Clubman", {inicio:2007, fim:2024}], ["Aceman (électrique)", {inicio:2024, fim:null}], ["Paceman", {inicio:2012, fim:2016}], ["Cabrio", {inicio:2004, fim:null}], ["Coupé", {inicio:2011, fim:2015}], ["Roadster", {inicio:2012, fim:2015}], ["Mini classique", {inicio:1959, fim:2000}] ],
  "Mazda": [ ["Mazda2", {inicio:2002, fim:null}], ["Mazda2 Hybrid", {inicio:2022, fim:null}], ["Mazda3", {inicio:2003, fim:null}], ["Mazda5", {inicio:2005, fim:2018}], ["Mazda6", {inicio:2002, fim:2024}], ["CX-3", {inicio:2015, fim:2021}], ["CX-30", {inicio:2019, fim:null}], ["CX-5", {inicio:2012, fim:null}], ["CX-60", {inicio:2022, fim:null}], ["CX-7", {inicio:2006, fim:2012}], ["CX-80", {inicio:2024, fim:null}], ["CX-9", {inicio:2007, fim:2015}], ["MX-30 (électrique)", {inicio:2020, fim:null}], ["MX-5", {inicio:1989, fim:null}], ["RX-7", {inicio:1978, fim:2002}], ["RX-8", {inicio:2003, fim:2012}], ["Premacy", {inicio:1999, fim:2005}], ["Tribute", {inicio:2000, fim:2011}], ["MPV", {inicio:1988, fim:2016}], ["Demio", {inicio:1996, fim:2002}], ["121", {inicio:1975, fim:2003}], ["323", {inicio:1977, fim:2003}], ["626", {inicio:1979, fim:2002}], ["929", {inicio:1973, fim:1997}], ["Xedos 6", {inicio:1992, fim:1999}], ["Xedos 9", {inicio:1993, fim:2002}], ["B-Series (Pick-up)", {inicio:1961, fim:2006}], ["BT-50 (Pick-up)", {inicio:2006, fim:null}] ],
  "Cupra": [ ["Formentor", {inicio:2020, fim:null}], ["Leon", {inicio:2020, fim:null}], ["Leon Sportstourer", {inicio:2020, fim:null}], ["Born (électrique)", {inicio:2021, fim:null}], ["Ateca", {inicio:2018, fim:null}], ["Tavascan (électrique)", {inicio:2024, fim:null}], ["Terramar", {inicio:2024, fim:null}], ["Raval (électrique)", {inicio:2026, fim:null}] ],
  "Jeep": [ ["Avenger", {inicio:2023, fim:null}], ["Renegade", {inicio:2014, fim:null}], ["Compass", {inicio:2006, fim:null}], ["Wrangler", {inicio:1986, fim:null}], ["Cherokee", {inicio:1974, fim:null}], ["Grand Cherokee", {inicio:1992, fim:null}], ["Commander", {inicio:2005, fim:2010}], ["Gladiator (Pick-up)", {inicio:2020, fim:null}], ["Patriot", {inicio:2007, fim:2016}], ["Willys", {inicio:1941, fim:1968}], ["CJ-7", {inicio:1976, fim:1986}] ],
  "Fiat": [ ["500", {inicio:2007, fim:null}], ["500e (électrique)", {inicio:2020, fim:null}], ["500X", {inicio:2014, fim:null}], ["500L", {inicio:2012, fim:2022}], ["600", {inicio:2023, fim:null}], ["600e (électrique)", {inicio:2023, fim:null}], ["Panda", {inicio:1980, fim:null}], ["Grande Panda", {inicio:2024, fim:null}], ["Topolino (électrique)", {inicio:2023, fim:null}], ["Tipo", {inicio:1988, fim:null}], ["Doblò (2 places)", {inicio:2000, fim:null}], ["Doblò (4 places)", {inicio:2000, fim:null}], ["E-Doblò (électrique · 2 places)", {inicio:2022, fim:null}], ["E-Doblò (électrique · 4 places)", {inicio:2022, fim:null}], ["Ducato (2 places)", {inicio:1981, fim:null}], ["Ducato (4 places)", {inicio:1981, fim:null}], ["E-Ducato (électrique · 2 places)", {inicio:2021, fim:null}], ["E-Ducato (électrique · 4 places)", {inicio:2021, fim:null}], ["Scudo (2 places)", {inicio:1996, fim:null}], ["Scudo (4 places)", {inicio:1996, fim:null}], ["E-Scudo (électrique · 2 places)", {inicio:2022, fim:null}], ["E-Scudo (électrique · 4 places)", {inicio:2022, fim:null}], ["Fiorino (2 places)", {inicio:1977, fim:null}], ["Fiorino (4 places)", {inicio:1977, fim:null}], ["Talento (2 places)", {inicio:2016, fim:2021}], ["Talento (4 places)", {inicio:2016, fim:2021}], ["Qubo", {inicio:2008, fim:2020}], ["Ulysse", {inicio:1994, fim:null}], ["Punto", {inicio:1993, fim:2018}], ["Grande Punto", {inicio:2005, fim:2012}], ["Bravo", {inicio:1995, fim:2014}], ["Brava", {inicio:1995, fim:2001}], ["Stilo", {inicio:2001, fim:2010}], ["Croma", {inicio:1985, fim:2011}], ["Marea", {inicio:1996, fim:2002}], ["Multipla", {inicio:1998, fim:2010}], ["Idea", {inicio:2003, fim:2012}], ["Sedici", {inicio:2006, fim:2014}], ["Freemont", {inicio:2011, fim:2016}], ["Coupé", {inicio:1993, fim:2000}], ["Barchetta", {inicio:1995, fim:2005}], ["Seicento", {inicio:1998, fim:2010}], ["Cinquecento", {inicio:1991, fim:1998}], ["Uno", {inicio:1983, fim:2013}], ["Palio", {inicio:1996, fim:2017}], ["Siena", {inicio:1996, fim:2016}], ["Tempra", {inicio:1990, fim:1999}], ["Regata", {inicio:1983, fim:1990}], ["Ritmo", {inicio:1978, fim:1988}], ["Duna", {inicio:1987, fim:2000}], ["127", {inicio:1971, fim:1987}], ["128", {inicio:1969, fim:1985}], ["131", {inicio:1974, fim:1984}], ["500 (classique)", {inicio:1957, fim:1975}], ["Strada (Pick-up)", {inicio:1996, fim:2020}] ],
  "Honda": [ ["Jazz", {inicio:2001, fim:null}], ["Civic", {inicio:1972, fim:null}], ["HR-V", {inicio:1999, fim:null}], ["CR-V", {inicio:1995, fim:null}], ["ZR-V", {inicio:2023, fim:null}], ["e:Ny1 (électrique)", {inicio:2023, fim:null}], ["Honda e (électrique)", {inicio:2020, fim:2024}], ["Accord", {inicio:1976, fim:2018}], ["Insight", {inicio:1999, fim:2014}], ["CR-Z", {inicio:2010, fim:2016}], ["FR-V", {inicio:2004, fim:2009}], ["Stream", {inicio:2000, fim:2006}], ["Shuttle", {inicio:1994, fim:2002}], ["Concerto", {inicio:1988, fim:1994}], ["Logo", {inicio:1996, fim:2001}], ["City", {inicio:1981, fim:null}], ["Integra", {inicio:1985, fim:2006}], ["Prelude", {inicio:1978, fim:2001}], ["Legend", {inicio:1985, fim:2012}], ["S2000", {inicio:1999, fim:2009}], ["NSX", {inicio:1990, fim:2022}] ],
  "Suzuki": [ ["Swift", {inicio:1983, fim:null}], ["Vitara", {inicio:1988, fim:null}], ["Grand Vitara", {inicio:1998, fim:null}], ["S-Cross", {inicio:2013, fim:null}], ["SX4", {inicio:2006, fim:2014}], ["Ignis", {inicio:2000, fim:null}], ["Jimny", {inicio:1970, fim:null}], ["Across", {inicio:2020, fim:null}], ["Swace", {inicio:2020, fim:null}], ["e Vitara (électrique)", {inicio:2025, fim:null}], ["Baleno", {inicio:1995, fim:2019}], ["Celerio", {inicio:2014, fim:2019}], ["Splash", {inicio:2008, fim:2014}], ["Alto", {inicio:1979, fim:2014}], ["Wagon R+", {inicio:1997, fim:2006}], ["Liana", {inicio:2001, fim:2007}], ["Kizashi", {inicio:2009, fim:2015}], ["Cappuccino", {inicio:1991, fim:1998}], ["Samurai", {inicio:1985, fim:2004}], ["SJ 413", {inicio:1984, fim:1998}], ["Santana", {inicio:1985, fim:2004}], ["Carry", {inicio:1961, fim:null}] ],
  "Land Rover": [ ["Defender", {inicio:1983, fim:null}], ["Discovery", {inicio:1989, fim:null}], ["Discovery Sport", {inicio:2014, fim:null}], ["Range Rover", {inicio:1970, fim:null}], ["Range Rover Sport", {inicio:2005, fim:null}], ["Range Rover Evoque", {inicio:2011, fim:null}], ["Range Rover Velar", {inicio:2017, fim:null}], ["Freelander", {inicio:1997, fim:2014}], ["Series I", {inicio:1948, fim:1958}], ["Series II", {inicio:1958, fim:1971}], ["Series III", {inicio:1971, fim:1985}], ["88", {inicio:1958, fim:1985}], ["109", {inicio:1958, fim:1985}] ],
  "Smart": [ ["ForTwo", {inicio:1998, fim:2024}], ["ForTwo Cabrio", {inicio:2000, fim:2024}], ["ForFour", {inicio:2004, fim:2021}], ["#1 (électrique)", {inicio:2022, fim:null}], ["#3 (électrique)", {inicio:2023, fim:null}], ["#5 (électrique)", {inicio:2025, fim:null}], ["Roadster", {inicio:2003, fim:2006}], ["Crossblade", {inicio:2002, fim:2003}] ],
  "Porsche": [ ["Macan", {inicio:2014, fim:null}], ["Macan EV (électrique)", {inicio:2024, fim:null}], ["Cayenne", {inicio:2002, fim:null}], ["Panamera", {inicio:2009, fim:null}], ["Taycan (électrique)", {inicio:2019, fim:null}], ["911", {inicio:1963, fim:null}], ["718 Boxster", {inicio:1996, fim:null}], ["718 Cayman", {inicio:2005, fim:null}], ["Carrera GT", {inicio:2003, fim:2007}], ["912", {inicio:1965, fim:1969}], ["924", {inicio:1976, fim:1988}], ["928", {inicio:1977, fim:1995}], ["944", {inicio:1982, fim:1991}], ["968", {inicio:1991, fim:1995}], ["356", {inicio:1948, fim:1965}] ],
  "Mitsubishi": [ ["Space Star", {inicio:1998, fim:null}], ["ASX", {inicio:2010, fim:null}], ["Eclipse Cross", {inicio:2017, fim:null}], ["Outlander", {inicio:2001, fim:null}], ["L200 (Pick-up)", {inicio:1978, fim:null}], ["Colt", {inicio:1978, fim:null}], ["Pajero", {inicio:1982, fim:2021}], ["Pajero Pinin", {inicio:1998, fim:2007}], ["Pajero Sport", {inicio:1996, fim:null}], ["Montero", {inicio:1982, fim:2006}], ["Lancer", {inicio:1973, fim:2017}], ["Carisma", {inicio:1995, fim:2004}], ["Galant", {inicio:1969, fim:2012}], ["Sigma", {inicio:1990, fim:1996}], ["Grandis", {inicio:2003, fim:2011}], ["Space Runner", {inicio:1991, fim:2002}], ["Space Wagon", {inicio:1983, fim:2004}], ["Space Gear", {inicio:1994, fim:2006}], ["3000GT", {inicio:1990, fim:2001}], ["Starion", {inicio:1982, fim:1989}], ["i-MiEV (électrique)", {inicio:2010, fim:2020}], ["Canter", {inicio:1963, fim:null}], ["L300", {inicio:1979, fim:2013}], ["L400", {inicio:1994, fim:2007}] ],
  "Lexus": [ ["UX", {inicio:2018, fim:null}], ["UX 300e (électrique)", {inicio:2020, fim:null}], ["LBX", {inicio:2023, fim:null}], ["NX", {inicio:2014, fim:null}], ["RX", {inicio:1998, fim:null}], ["RZ (électrique)", {inicio:2023, fim:null}], ["GX", {inicio:2002, fim:null}], ["LX", {inicio:1995, fim:null}], ["ES", {inicio:1989, fim:null}], ["IS", {inicio:1998, fim:null}], ["GS", {inicio:1991, fim:2020}], ["LS", {inicio:1989, fim:null}], ["LC", {inicio:2017, fim:null}], ["RC", {inicio:2014, fim:null}], ["SC", {inicio:1991, fim:2010}], ["LM", {inicio:2019, fim:null}], ["CT 200h", {inicio:2011, fim:2022}] ],
  "MG": [ ["MG3", {inicio:2024, fim:null}], ["MG4 (électrique)", {inicio:2022, fim:null}], ["MG5 (électrique)", {inicio:2021, fim:null}], ["ZS", {inicio:2019, fim:null}], ["ZS EV (électrique)", {inicio:2019, fim:null}], ["HS", {inicio:2019, fim:null}], ["S5 EV (électrique)", {inicio:2025, fim:null}], ["Cyberster (électrique)", {inicio:2024, fim:null}], ["Marvel R (électrique)", {inicio:2021, fim:2023}], ["MG6", {inicio:2010, fim:2016}], ["ZR", {inicio:2001, fim:2005}], ["ZT", {inicio:2001, fim:2005}], ["TF", {inicio:2002, fim:2011}], ["MGF", {inicio:1995, fim:2002}], ["MGA", {inicio:1955, fim:1962}], ["MGB", {inicio:1962, fim:1980}], ["Midget", {inicio:1961, fim:1979}] ],
  "BYD": [ ["Dolphin (électrique)", {inicio:2023, fim:null}], ["Dolphin Surf (électrique)", {inicio:2025, fim:null}], ["Atto 2 (électrique)", {inicio:2025, fim:null}], ["Atto 3 (électrique)", {inicio:2022, fim:null}], ["Seal (électrique)", {inicio:2023, fim:null}], ["Seal U (électrique)", {inicio:2024, fim:null}], ["Sealion 6", {inicio:2024, fim:null}], ["Sealion 7 (électrique)", {inicio:2025, fim:null}], ["Han (électrique)", {inicio:2022, fim:null}], ["Tang (électrique)", {inicio:2022, fim:null}], ["Seagull (électrique)", {inicio:2024, fim:null}] ],
  "Alfa Romeo": [ ["Giulietta", {inicio:2010, fim:2020}], ["Giulia", {inicio:2016, fim:null}], ["Stelvio", {inicio:2017, fim:null}], ["Tonale", {inicio:2022, fim:null}], ["Junior", {inicio:2024, fim:null}], ["MiTo", {inicio:2008, fim:2018}], ["147", {inicio:2000, fim:2010}], ["156", {inicio:1997, fim:2007}], ["159", {inicio:2005, fim:2011}], ["166", {inicio:1998, fim:2007}], ["164", {inicio:1987, fim:1998}], ["155", {inicio:1992, fim:1998}], ["145", {inicio:1994, fim:2001}], ["146", {inicio:1994, fim:2001}], ["GT", {inicio:2003, fim:2010}], ["GTV", {inicio:1974, fim:2005}], ["Brera", {inicio:2005, fim:2010}], ["Spider", {inicio:1966, fim:2010}], ["75", {inicio:1985, fim:1992}], ["90", {inicio:1984, fim:1987}], ["33", {inicio:1983, fim:1995}], ["Alfasud", {inicio:1971, fim:1989}], ["Alfetta", {inicio:1972, fim:1984}], ["Arna", {inicio:1983, fim:1987}], ["Giulietta (classique)", {inicio:1954, fim:1965}] ],
  "Polestar": [ ["Polestar 2 (électrique)", {inicio:2020, fim:null}], ["Polestar 3 (électrique)", {inicio:2023, fim:null}], ["Polestar 4 (électrique)", {inicio:2024, fim:null}], ["Polestar 5 (électrique)", {inicio:2025, fim:null}], ["Polestar 1", {inicio:2019, fim:2021}] ],
  "Subaru": [ ["Impreza", {inicio:1992, fim:null}], ["XV / Crosstrek", {inicio:2012, fim:null}], ["Forester", {inicio:1997, fim:null}], ["Outback", {inicio:1994, fim:null}], ["Legacy", {inicio:1989, fim:2020}], ["Levorg", {inicio:2014, fim:2020}], ["Solterra (électrique)", {inicio:2022, fim:null}], ["BRZ", {inicio:2012, fim:null}], ["WRX", {inicio:1992, fim:null}], ["Tribeca", {inicio:2005, fim:2014}], ["Trezia", {inicio:2011, fim:2014}], ["SVX", {inicio:1991, fim:1997}], ["Justy", {inicio:1984, fim:2011}], ["Vivio", {inicio:1992, fim:1998}], ["Libero", {inicio:1983, fim:1999}] ],
  "DS Automobiles": [ ["DS 3", {inicio:2010, fim:null}], ["DS 3 Crossback", {inicio:2019, fim:null}], ["DS 4", {inicio:2011, fim:null}], ["DS 4 Crossback", {inicio:2015, fim:2018}], ["DS 5", {inicio:2011, fim:2018}], ["DS 7", {inicio:2017, fim:null}], ["DS 7 Crossback", {inicio:2017, fim:2022}], ["DS 9", {inicio:2020, fim:null}], ["DS N°8 (électrique)", {inicio:2025, fim:null}] ],
  "Lancia": [ ["Ypsilon", {inicio:1985, fim:null}], ["Delta", {inicio:1979, fim:2014}], ["Musa", {inicio:2004, fim:2012}], ["Thesis", {inicio:2001, fim:2009}], ["Phedra", {inicio:2002, fim:2010}], ["Lybra", {inicio:1998, fim:2005}], ["Kappa", {inicio:1994, fim:2001}], ["Zeta", {inicio:1995, fim:2002}], ["Dedra", {inicio:1989, fim:1999}], ["Thema", {inicio:1984, fim:2014}], ["Prisma", {inicio:1982, fim:1989}], ["Y10", {inicio:1985, fim:1995}], ["Beta", {inicio:1972, fim:1984}], ["Trevi", {inicio:1980, fim:1984}], ["Gamma", {inicio:1976, fim:1984}], ["Fulvia", {inicio:1963, fim:1976}] ],
  "Alpine": [ ["A110", {inicio:1961, fim:null}], ["A290 (électrique)", {inicio:2024, fim:null}], ["A390 (électrique)", {inicio:2025, fim:null}], ["A310", {inicio:1971, fim:1984}], ["GTA", {inicio:1984, fim:1991}], ["A610", {inicio:1991, fim:1995}] ],
  "Abarth": [ ["595", {inicio:2008, fim:2023}], ["695", {inicio:2009, fim:null}], ["500e (électrique)", {inicio:2023, fim:null}], ["600e (électrique)", {inicio:2024, fim:null}], ["124 Spider", {inicio:2016, fim:2019}], ["Grande Punto", {inicio:2007, fim:2010}], ["Punto Evo", {inicio:2010, fim:2014}] ],
  "Genesis": [ ["G70", {inicio:2021, fim:null}], ["G80", {inicio:2021, fim:null}], ["GV60 (électrique)", {inicio:2022, fim:null}], ["GV70", {inicio:2021, fim:null}], ["GV80", {inicio:2021, fim:null}] ],
  "Xpeng": [ ["G6 (électrique)", {inicio:2024, fim:null}], ["G9 (électrique)", {inicio:2024, fim:null}], ["P7 (électrique)", {inicio:2024, fim:null}], ["X9 (électrique)", {inicio:2025, fim:null}] ],
  "NIO": [ ["ET5 (électrique)", {inicio:2023, fim:null}], ["ET7 (électrique)", {inicio:2022, fim:null}], ["EL6 (électrique)", {inicio:2023, fim:null}], ["EL7 (électrique)", {inicio:2023, fim:null}] ],
  "Leapmotor": [ ["T03 (électrique)", {inicio:2024, fim:null}], ["C10 (électrique)", {inicio:2024, fim:null}], ["B10 (électrique)", {inicio:2025, fim:null}] ],
  "Omoda": [ ["5", {inicio:2024, fim:null}], ["7", {inicio:2025, fim:null}], ["9", {inicio:2025, fim:null}] ],
  "Jaecoo": [ ["7", {inicio:2024, fim:null}], ["5", {inicio:2025, fim:null}], ["8", {inicio:2025, fim:null}] ],
  "Lynk & Co": [ ["01", {inicio:2021, fim:null}], ["02 (électrique)", {inicio:2024, fim:null}] ],
  "Maxus": [ ["eDeliver 3 (électrique · 2 places)", {inicio:2020, fim:null}], ["eDeliver 3 (électrique · 4 places)", {inicio:2020, fim:null}], ["eDeliver 7 (électrique)", {inicio:2024, fim:null}], ["eDeliver 9 (électrique · 2 places)", {inicio:2021, fim:null}], ["eDeliver 9 (électrique · 4 places)", {inicio:2021, fim:null}], ["Deliver 9 (2 places)", {inicio:2020, fim:null}], ["Deliver 9 (4 places)", {inicio:2020, fim:null}], ["T60 (Pick-up)", {inicio:2017, fim:null}], ["T90 EV (Pick-up)", {inicio:2022, fim:null}], ["Euniq 5", {inicio:2020, fim:null}] ],
  "Ineos": [ ["Grenadier", {inicio:2022, fim:null}], ["Quartermaster (Pick-up)", {inicio:2024, fim:null}] ],
  "Isuzu": [ ["D-Max (Pick-up)", {inicio:2002, fim:null}], ["Trooper", {inicio:1981, fim:2004}], ["Rodeo (Pick-up)", {inicio:1988, fim:2003}], ["Campo (Pick-up)", {inicio:1972, fim:1994}], ["Midi", {inicio:1980, fim:1995}], ["N-Series", {inicio:1959, fim:null}] ],
  "SsangYong / KGM": [ ["Musso (Pick-up)", {inicio:1993, fim:null}], ["Korando", {inicio:1983, fim:null}], ["Tivoli", {inicio:2015, fim:null}], ["Rexton", {inicio:2001, fim:null}], ["Torres", {inicio:2022, fim:null}], ["Actyon", {inicio:2005, fim:2017}], ["Kyron", {inicio:2005, fim:2014}], ["Rodius", {inicio:2004, fim:2019}], ["Chairman", {inicio:1997, fim:2017}], ["Istana", {inicio:1995, fim:2003}] ],
  "Infiniti": [
    ["Q30", {inicio:2016, fim:2019}], ["QX30", {inicio:2016, fim:2019}],
    ["Q50", {inicio:2013, fim:null}], ["Q60", {inicio:2016, fim:null}],
    ["Q70", {inicio:2014, fim:2019}], ["QX50", {inicio:2013, fim:null}],
    ["QX60", {inicio:2013, fim:null}], ["QX70", {inicio:2013, fim:2017}],
    ["QX80", {inicio:2013, fim:null}]
  ],
  "Jaguar": [ ["E-Pace", {inicio:2017, fim:null}], ["F-Pace", {inicio:2016, fim:null}], ["I-Pace (électrique)", {inicio:2018, fim:null}], ["XE", {inicio:2015, fim:2024}], ["XF", {inicio:2007, fim:null}], ["XJ", {inicio:1968, fim:2019}], ["XK", {inicio:1996, fim:2014}], ["F-Type", {inicio:2013, fim:2024}], ["S-Type", {inicio:1999, fim:2008}], ["X-Type", {inicio:2001, fim:2009}], ["E-Type", {inicio:1961, fim:1975}], ["Mark 2", {inicio:1959, fim:1967}] ],
  "Chevrolet": [ ["Spark", {inicio:2005, fim:2016}], ["Aveo", {inicio:2002, fim:2015}], ["Cruze", {inicio:2008, fim:2016}], ["Captiva", {inicio:2006, fim:2016}], ["Orlando", {inicio:2010, fim:2015}], ["Trax", {inicio:2013, fim:2016}], ["Matiz", {inicio:1998, fim:2010}], ["Kalos", {inicio:2002, fim:2008}], ["Lacetti", {inicio:2002, fim:2011}], ["Nubira", {inicio:1997, fim:2011}], ["Tacuma", {inicio:2000, fim:2008}], ["Rezzo", {inicio:2000, fim:2008}], ["Epica", {inicio:2006, fim:2011}], ["Evanda", {inicio:2002, fim:2006}], ["Camaro", {inicio:1966, fim:null}], ["Corvette", {inicio:1953, fim:null}], ["Blazer", {inicio:1969, fim:null}] ],
  "Chrysler": [ ["300C", {inicio:2004, fim:2014}], ["Voyager", {inicio:1984, fim:2016}], ["Grand Voyager", {inicio:1990, fim:2016}], ["PT Cruiser", {inicio:2000, fim:2010}], ["Sebring", {inicio:1995, fim:2010}], ["Neon", {inicio:1994, fim:2005}], ["Stratus", {inicio:1995, fim:2006}], ["Crossfire", {inicio:2003, fim:2008}], ["Vision", {inicio:1993, fim:1997}], ["LHS", {inicio:1994, fim:2001}] ],
  "Dodge": [ ["Journey", {inicio:2008, fim:2020}], ["Caliber", {inicio:2006, fim:2012}], ["Nitro", {inicio:2006, fim:2012}], ["Avenger", {inicio:1994, fim:2014}], ["Charger", {inicio:1966, fim:null}], ["Challenger", {inicio:1969, fim:2023}], ["Durango", {inicio:1997, fim:null}], ["RAM 1500 (Pick-up)", {inicio:1981, fim:null}] ],
  "RAM": [ ["1500 (Pick-up)", {inicio:2010, fim:null}], ["2500 (Pick-up)", {inicio:2010, fim:null}], ["ProMaster", {inicio:2013, fim:null}] ],
  "Rover": [ ["25", {inicio:1999, fim:2005}], ["45", {inicio:1999, fim:2005}], ["75", {inicio:1998, fim:2005}], ["100", {inicio:1990, fim:1998}], ["200", {inicio:1984, fim:1999}], ["400", {inicio:1990, fim:1999}], ["600", {inicio:1993, fim:1999}], ["800", {inicio:1986, fim:1999}], ["Streetwise", {inicio:2003, fim:2005}], ["Metro", {inicio:1980, fim:1998}], ["Montego", {inicio:1984, fim:1995}], ["Maestro", {inicio:1983, fim:1994}], ["SD1", {inicio:1976, fim:1986}] ],
  "Saab": [ ["9-3", {inicio:1998, fim:2012}], ["9-5", {inicio:1997, fim:2012}], ["900", {inicio:1978, fim:1998}], ["9000", {inicio:1984, fim:1998}], ["99", {inicio:1968, fim:1984}], ["96", {inicio:1960, fim:1980}] ],
  "Daewoo": [ ["Matiz", {inicio:1998, fim:2005}], ["Lanos", {inicio:1997, fim:2002}], ["Nubira", {inicio:1997, fim:2002}], ["Leganza", {inicio:1997, fim:2002}], ["Kalos", {inicio:2002, fim:2005}], ["Tacuma", {inicio:2000, fim:2005}], ["Espero", {inicio:1990, fim:1997}], ["Nexia", {inicio:1994, fim:1997}], ["Racer", {inicio:1986, fim:1994}], ["Musso", {inicio:1998, fim:2002}], ["Korando", {inicio:1998, fim:2002}] ],
  "Daihatsu": [ ["Terios", {inicio:1997, fim:2017}], ["Sirion", {inicio:1998, fim:2016}], ["Cuore", {inicio:1980, fim:2012}], ["Materia", {inicio:2006, fim:2012}], ["Copen", {inicio:2002, fim:null}], ["YRV", {inicio:2000, fim:2005}], ["Move", {inicio:1995, fim:null}], ["Charade", {inicio:1977, fim:2000}], ["Applause", {inicio:1989, fim:2000}], ["Feroza", {inicio:1988, fim:1998}], ["Rocky", {inicio:1984, fim:2002}], ["Hijet", {inicio:1960, fim:null}] ],
  "Lada": [ ["Niva", {inicio:1977, fim:null}], ["Samara", {inicio:1984, fim:2013}], ["Riva / 2107", {inicio:1980, fim:2012}], ["110", {inicio:1995, fim:2010}], ["Kalina", {inicio:2004, fim:2018}], ["Granta", {inicio:2011, fim:null}], ["Vesta", {inicio:2015, fim:null}] ],
  "Proton": [ ["Satria", {inicio:1994, fim:2005}], ["Wira", {inicio:1993, fim:2009}], ["Persona", {inicio:1993, fim:null}], ["Impian", {inicio:2001, fim:2010}], ["Savvy", {inicio:2005, fim:2011}], ["Gen-2", {inicio:2004, fim:2012}] ],
  "Tata": [ ["Indica", {inicio:1998, fim:2018}], ["Xenon (Pick-up)", {inicio:2007, fim:2019}], ["Telcoline (Pick-up)", {inicio:1988, fim:2007}], ["Safari", {inicio:1998, fim:null}], ["Sumo", {inicio:1994, fim:2019}] ],
  "Talbot": [ ["Horizon", {inicio:1977, fim:1987}], ["Samba", {inicio:1981, fim:1986}], ["Solara", {inicio:1980, fim:1986}], ["Alpine", {inicio:1975, fim:1986}], ["Tagora", {inicio:1980, fim:1983}], ["Express", {inicio:1985, fim:1994}] ],
  "UMM": [ ["Alter II", {inicio:1985, fim:1996}], ["Alter 4x4", {inicio:1978, fim:1996}], ["Cournil", {inicio:1977, fim:1985}], ["Transcat", {inicio:1988, fim:1993}] ],
  "Portaro": [ ["Campeiro", {inicio:1975, fim:1995}], ["Celta", {inicio:1980, fim:1995}], ["Pastor", {inicio:1982, fim:1995}] ],
  "Austin": [ ["Mini", {inicio:1959, fim:2000}], ["Metro", {inicio:1980, fim:1990}], ["Maestro", {inicio:1983, fim:1994}], ["Montego", {inicio:1984, fim:1995}], ["Allegro", {inicio:1973, fim:1982}], ["Princess", {inicio:1975, fim:1981}] ],
  "Morris": [ ["Mini", {inicio:1959, fim:1969}], ["Marina", {inicio:1971, fim:1980}], ["Ital", {inicio:1980, fim:1984}], ["Minor", {inicio:1948, fim:1971}] ],
  "Triumph": [ ["Spitfire", {inicio:1962, fim:1980}], ["TR6", {inicio:1968, fim:1976}], ["TR7", {inicio:1974, fim:1981}], ["Dolomite", {inicio:1972, fim:1980}], ["Acclaim", {inicio:1981, fim:1984}] ],
  "Maserati": [ ["Ghibli", {inicio:2013, fim:null}], ["Levante", {inicio:2016, fim:null}], ["Grecale", {inicio:2022, fim:null}], ["Quattroporte", {inicio:1963, fim:null}], ["GranTurismo", {inicio:2007, fim:null}], ["GranCabrio", {inicio:2010, fim:null}], ["MC20", {inicio:2020, fim:null}], ["3200 GT", {inicio:1998, fim:2002}], ["Coupé", {inicio:2002, fim:2007}] ],
  "Ferrari": [ ["Roma", {inicio:2020, fim:null}], ["Portofino", {inicio:2017, fim:null}], ["296", {inicio:2021, fim:null}], ["SF90", {inicio:2019, fim:null}], ["812", {inicio:2017, fim:null}], ["F8", {inicio:2019, fim:2022}], ["488", {inicio:2015, fim:2019}], ["458", {inicio:2009, fim:2015}], ["California", {inicio:2008, fim:2017}], ["Purosangue", {inicio:2022, fim:null}], ["F430", {inicio:2004, fim:2009}], ["360 Modena", {inicio:1999, fim:2005}], ["Testarossa", {inicio:1984, fim:1996}] ],
  "Lamborghini": [ ["Urus", {inicio:2018, fim:null}], ["Huracán", {inicio:2014, fim:null}], ["Revuelto", {inicio:2023, fim:null}], ["Aventador", {inicio:2011, fim:2022}], ["Gallardo", {inicio:2003, fim:2013}], ["Murciélago", {inicio:2001, fim:2010}], ["Diablo", {inicio:1990, fim:2001}], ["Countach", {inicio:1974, fim:1990}] ],
  "Bentley": [ ["Continental GT", {inicio:2003, fim:null}], ["Flying Spur", {inicio:2005, fim:null}], ["Bentayga", {inicio:2015, fim:null}], ["Mulsanne", {inicio:2010, fim:2020}], ["Arnage", {inicio:1998, fim:2009}] ],
  "Aston Martin": [ ["DB11", {inicio:2016, fim:2023}], ["DB12", {inicio:2023, fim:null}], ["DBX", {inicio:2020, fim:null}], ["Vantage", {inicio:2005, fim:null}], ["DBS", {inicio:2007, fim:null}], ["Rapide", {inicio:2010, fim:2020}], ["DB9", {inicio:2004, fim:2016}], ["Vanquish", {inicio:2001, fim:null}] ],
  "Rolls-Royce": [ ["Ghost", {inicio:2009, fim:null}], ["Phantom", {inicio:2003, fim:null}], ["Cullinan", {inicio:2018, fim:null}], ["Wraith", {inicio:2013, fim:2023}], ["Dawn", {inicio:2015, fim:2023}], ["Spectre (électrique)", {inicio:2023, fim:null}] ],
  "Cadillac": [ ["Escalade", {inicio:1998, fim:null}], ["CTS", {inicio:2002, fim:2019}], ["BLS", {inicio:2005, fim:2010}], ["SRX", {inicio:2003, fim:2016}], ["XT4", {inicio:2018, fim:null}], ["Lyriq (électrique)", {inicio:2022, fim:null}], ["Seville", {inicio:1975, fim:2004}] ],
  "Iveco": [ ["Daily (2 places)", {inicio:1978, fim:null}], ["Daily (4 places)", {inicio:1978, fim:null}], ["eDaily (électrique)", {inicio:2022, fim:null}], ["Eurocargo", {inicio:1991, fim:null}], ["TurboDaily", {inicio:1990, fim:1999}], ["Massif", {inicio:2007, fim:2011}] ],
  "Piaggio": [ ["Porter", {inicio:1992, fim:null}], ["Porter Maxxi", {inicio:2004, fim:null}], ["Porter NP6", {inicio:2021, fim:null}], ["Ape", {inicio:1948, fim:null}] ],
  "Aixam": [ ["City", {inicio:2010, fim:null}], ["Crossline", {inicio:2010, fim:null}], ["Coupé", {inicio:2012, fim:null}], ["e-City (électrique)", {inicio:2015, fim:null}], ["Minauto", {inicio:2009, fim:null}], ["Crossover", {inicio:2014, fim:null}] ],
  "Ligier": [ ["JS50", {inicio:2013, fim:null}], ["JS60", {inicio:2022, fim:null}], ["Myli (électrique)", {inicio:2023, fim:null}], ["IXO", {inicio:2008, fim:2014}], ["Nova", {inicio:1998, fim:2005}] ],
  "Microcar": [ ["M.Go", {inicio:2008, fim:null}], ["Dué", {inicio:2010, fim:null}], ["M8", {inicio:2011, fim:2017}], ["Virgo", {inicio:1998, fim:2006}] ],
  "Chatenet": [ ["CH26", {inicio:2004, fim:null}], ["CH30", {inicio:2010, fim:null}], ["CH32", {inicio:2014, fim:null}], ["Barooder", {inicio:1997, fim:2010}] ],
  "Great Wall": [ ["Steed (Pick-up)", {inicio:2006, fim:2021}], ["Wingle (Pick-up)", {inicio:2006, fim:null}], ["Hover", {inicio:2005, fim:2013}] ],
  "Bedford": [ ["Rascal", {inicio:1986, fim:1994}], ["Midi", {inicio:1980, fim:1994}], ["CF", {inicio:1969, fim:1988}] ]
};

  // Marcas com registros no mercado alemão em 2026 que ainda não tinham modelos na base.
  // Elas aparecem no seletor e o cliente pode informar manualmente o modelo e o ano.
  const MARCAS_MERCADO = [
    "Chery", "DAF Trucks", "Deepal", "Dongfeng", "Fisker", "Geely", "JAC",
    "Lotus", "Lucid", "MAN", "Morgan", "Togg", "VinFast", "Zeekr"
  ];

  const kits = {
    carro: [
      {
        id: "carro_sem_porta",
        nome: "Kit intérieur (sans coffre)",
        desc: "Sur mesure · Retient la saleté et les liquides",
        compare: 129.00,
        sale: 49.90,
        save: 79.10,
        tag: "Meilleure vente",
        tagType: "best",
        img: "images/prod1.webp"
      },
      {
        id: "carro_com_porta",
        nome: "Kit intérieur + coffre",
        desc: "Sur mesure · Protection complète",
        compare: 169.00,
        sale: 64.90,
        save: 104.10,
        tag: "Kit complet",
        tagType: "best",
        img: "images/foto1.webp"
      }
    ],
    picape: [
      {
        id: "picape_sem_cacamba",
        nome: "Kit intérieur (sans benne)",
        desc: "Sur mesure · Ajustement parfait",
        compare: 189.00,
        sale: 69.90,
        save: 119.10,
        tag: "MEILLEUR PRIX",
        tagType: "price",
        img: "images/prod1.webp"
      },
      {
        id: "picape_com_cacamba",
        nome: "Kit intérieur + benne",
        desc: "Sur mesure · Protection intégrale",
        compare: 229.00,
        sale: 84.90,
        save: 144.10,
        tag: "Kit complet",
        tagType: "best",
        img: "images/cacamba.jpeg"
      }
    ]
  };

const checkoutLinks = {"carro_sem_porta": {"preto": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes", "cinza": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes", "bege": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes"}, "carro_com_porta": {"preto": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes", "cinza": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes", "bege": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes"}, "picape_sem_cacamba": {"preto": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes", "cinza": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes", "bege": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes"}, "picape_com_cacamba": {"preto": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes", "cinza": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes", "bege": "https://app.aclickmarketing.com/o/mattenschmiede-tapetes"}};

  const st = {
    tipo: location.pathname.includes("pickup") ? "picape" : "carro",
    marca: null,
    modelo: null,
    ano: null,
    cor: "preto",
    textura: "Circuito / Tech",
    kit: null
  };


  const fmtEUR = (v) => v.toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
  const fmtEURPlain = (v) => v.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  function getYearsRange(inicio, fim){
    const agora = new Date().getFullYear();

    /* Margem de matrícula.
       A data de FIM na tabela é quando o modelo saiu de produção - não é a
       última matrícula em Portugal. Um Kadjar "até 2022" ainda foi matriculado
       aqui em 2023 (stock do concessionário) e continua a entrar importado
       depois disso. Sem esta folga, esse cliente não encontra o ano da sua
       matrícula na lista - e quem não encontra o próprio carro desconfia da
       loja e vai-se embora.
       O risco é assimétrico: um ano a mais na lista não custa nada, porque
       ninguém o escolhe; um ano a menos custa a venda. Daí a folga, sempre
       limitada ao ano corrente. */
    const MARGEM_MATRICULA = 2;
    const end = fim == null ? agora : Math.min(fim + MARGEM_MATRICULA, agora);

    const arr = [];
    for(let y = end; y >= inicio; y--) arr.push(y);
    return arr;
  }

  function labelCor(c){
    if(c === "preto") return "Noir";
    if(c === "cinza") return "Gris";
    if(c === "bege") return "Beige";
    return "";
  }

  function labelTextura(value){
    if(value === "Circuito / Tech") return "Circuit / Tech";
    if(value === "Fluxo / Ondas") return "Vagues / Ondulations";
    if(value === "Pedra / Off-Road") return "Pierre / Tout-terrain";
    return value || "";
  }

  function getKitName(tipo, id){
    const arr = kits[tipo] || [];
    const found = arr.find((k) => k.id === id);
    return found ? found.nome : "";
  }

  function resolveCheckoutUrl(){
    if(!st.kit || !st.cor) return null;
    return checkoutLinks?.[st.kit]?.[st.cor] || null;
  }

  function calcDiscount(compare, sale){
    return Math.round(((compare - sale) / compare) * 100);
  }

  function escapeHtml(value){
    return String(value ?? "").replace(/[&<>"']/g, (char) => {
      const map = { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;", "'": "&#39;" };
      return map[char] || char;
    });
  }

  const mainImg = document.getElementById("ctaProMainImg");
  const thumbs = document.getElementById("ctaProThumbs");

  const typeButtons = Array.from(document.querySelectorAll(".rvTypeBtn"));
  const kitGrid = document.getElementById("rvKitGrid");
  const priceCompare = document.getElementById("rvPriceCompare");
  const priceMain = document.getElementById("rvPriceMain");
  const priceSave = document.getElementById("rvPriceSave");
  const confirmBtn = document.getElementById("rvConfirmBtn");

  const btnMarca = document.getElementById("rvBtnMarca");
  const btnModelo = document.getElementById("rvBtnModelo");
  const btnAno = document.getElementById("rvBtnAno");
  const txtMarca = document.getElementById("rvTxtMarca");
  const txtModelo = document.getElementById("rvTxtModelo");
  const txtAno = document.getElementById("rvTxtAno");
  const vehicleProgress = document.getElementById("rvVehicleProgress");
  const vehicleResult = document.getElementById("rvVehicleResult");
  const vehicleResultName = document.getElementById("rvVehicleResultName");
  const vehicleFind = document.getElementById("rvVehicleFind");
  const vehicleManual = document.getElementById("rvVehicleManual");

  const colorButtons = Array.from(document.querySelectorAll(".rvColor"));
  const textureButtons = Array.from(document.querySelectorAll(".rvTexture"));

  // Fotos na cor escolhida: as versões cinza e bege (mesma foto, só muda a cor do material) ficam em images/m/cores/
  const FOTOS_COR = {
    "images/txt1.webp": "txt1", "images/foto3.webp": "foto3", "images/txtpedra.webp": "txtpedra",
    "images/prod1.webp": "prod1", "images/foto1.webp": "foto1", "images/cacamba.jpeg": "cacamba"
  };
  const fotoCor = (src, cor) => {
    const base = FOTOS_COR[src];
    return base && (cor === "cinza" || cor === "bege") ? `images/m/cores/${base}-${cor}.webp` : src;
  };
  const fotoNaCor = (src) => fotoCor(src, st.cor);
  // Miniaturas leves (440px) pros cartões de kit, texturas e carrinho (otimização do celular, 05/10/2026)
  const MINIS = new Set(["11_98_11zon_450x", "cacamba", "cacamba-bege", "cacamba-cinza", "foto1", "foto1-bege", "foto1-cinza", "foto3", "foto3-bege", "foto3-cinza", "prod1", "prod1-bege", "prod1-cinza", "prod2", "txt1", "txt1-bege", "txt1-cinza", "txtpedra", "txtpedra-bege", "txtpedra-cinza"]);
  const fotoMini = (src) => { const nome = String(src || "").split("/").pop().replace(/\.[a-z]+$/i, ""); return MINIS.has(nome) ? `images/m/mini/${nome}.webp` : src; };
  const textureImgs = textureButtons.map((button) => button.querySelector("img")).filter(Boolean);
  textureImgs.forEach((img) => { if (!img.dataset.preto) img.dataset.preto = img.getAttribute("src"); });
  const mostrarCor = () => {
    textureImgs.forEach((img) => {
      const novo = fotoMini(fotoNaCor(img.dataset.preto));
      if (img.getAttribute("src") !== novo) img.src = novo;
    });
    renderKits();
  };
  const inlineError = document.getElementById("rvInlineError");

  const sheet = document.getElementById("rvSheet");
  const sheetBg = document.getElementById("rvSheetBg");
  const sheetClose = document.getElementById("rvSheetClose");
  const sheetTitle = document.getElementById("rvSheetTitle");
  const sheetSub = document.getElementById("rvSheetSub");
  const sheetSearch = document.getElementById("rvSheetSearch");
  const sheetSearchWrap = sheetSearch?.closest(".rvSheet__searchWrap");
  const sheetManualOpen = document.getElementById("rvSheetManualOpen");
  const sheetManualForm = document.getElementById("rvSheetManualForm");
  const sheetManualBack = document.getElementById("rvSheetManualBack");
  const manualMarca = document.getElementById("rvManualMarca");
  const manualAviso = document.getElementById("rvManualAviso");
  const manualModelo = document.getElementById("rvManualModelo");
  const manualAno = document.getElementById("rvManualAno");
  const manualError = document.getElementById("rvManualError");
  const sheetVehicle = document.getElementById("rvSheetVehicle");
  const sheetVehicleValue = document.getElementById("rvSheetVehicleValue");
  const sheetVehicleMarca = document.getElementById("rvSheetVehicleMarca");
  const sheetVehicleModelo = document.getElementById("rvSheetVehicleModelo");
  const sheetVehicleAno = document.getElementById("rvSheetVehicleAno");
  const manualVehicle = document.getElementById("rvManualVehicle");
  const manualVehicleValue = document.getElementById("rvManualVehicleValue");
  const manualVehicleStatus = document.getElementById("rvManualVehicleStatus");
  const sheetList = document.getElementById("rvSheetList");

  const modal = document.getElementById("rvModal");
  const modalBg = document.getElementById("rvModalBg");
  const modalClose = document.getElementById("rvModalClose");
  const modalBody = document.getElementById("rvModalBody");
  const modalEdit = document.getElementById("rvModalEdit");
  const modalGo = document.getElementById("rvModalGo");

  let priceBadge = null;
  let sheetCtx = null;

  // Galeria (variação 01 escolhida pelo Gabriel, 05/10/2026): miniaturas, setas e deslizar o dedo na foto grande.
  const fotosGaleria = thumbs ? Array.from(thumbs.querySelectorAll(".ctaPro__thumb")) : [];
  let fotoAtual = Math.max(0, fotosGaleria.findIndex((b) => b.classList.contains("is-active")));
  function mostrarFoto(i){
    if(!fotosGaleria.length || !mainImg) return;
    fotoAtual = (i + fotosGaleria.length) % fotosGaleria.length;
    const btn = fotosGaleria[fotoAtual];
    const src = btn.getAttribute("data-src");
    if(src) mainImg.src = src;
    fotosGaleria.forEach((el) => el.classList.toggle("is-active", el === btn));
    // traz a miniatura ativa pra dentro da faixa, sem mexer na rolagem da página
    const faixa = thumbs.getBoundingClientRect();
    const r = btn.getBoundingClientRect();
    if(r.left < faixa.left || r.right > faixa.right){
      thumbs.scrollBy({ left: r.left - faixa.left - (faixa.width - r.width) / 2, behavior: "smooth" });
    }
  }
  thumbs?.addEventListener("click", (e) => {
    const btn = e.target.closest(".ctaPro__thumb");
    if(btn) mostrarFoto(fotosGaleria.indexOf(btn));
  });
  document.querySelector(".ctaPro__seta--ant")?.addEventListener("click", () => mostrarFoto(fotoAtual - 1));
  document.querySelector(".ctaPro__seta--prox")?.addEventListener("click", () => mostrarFoto(fotoAtual + 1));
  const palcoFoto = mainImg?.closest(".ctaPro__main");
  let toqueX = null;
  let toqueY = 0;
  palcoFoto?.addEventListener("touchstart", (e) => {
    toqueX = e.touches[0].clientX;
    toqueY = e.touches[0].clientY;
  }, { passive: true });
  palcoFoto?.addEventListener("touchend", (e) => {
    if(toqueX === null) return;
    const dx = e.changedTouches[0].clientX - toqueX;
    const dy = e.changedTouches[0].clientY - toqueY;
    toqueX = null;
    if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) mostrarFoto(fotoAtual + (dx < 0 ? 1 : -1));
  }, { passive: true });

  if(
    !kitGrid ||
    !confirmBtn ||
    !btnMarca ||
    !btnModelo ||
    !btnAno ||
    !txtMarca ||
    !txtModelo ||
    !txtAno ||
    !vehicleProgress ||
    !vehicleResult ||
    !vehicleResultName ||
    !vehicleFind ||
    !vehicleManual ||
    !sheet ||
    !sheetBg ||
    !sheetClose ||
    !sheetTitle ||
    !sheetSub ||
    !sheetSearch ||
    !sheetSearchWrap ||
    !sheetManualOpen ||
    !sheetManualForm ||
    !sheetManualBack ||
    !manualMarca ||
    !manualModelo ||
    !manualAno ||
    !manualError ||
    !sheetVehicle ||
    !sheetVehicleValue ||
    !sheetVehicleMarca ||
    !sheetVehicleModelo ||
    !sheetVehicleAno ||
    !manualVehicle ||
    !manualVehicleValue ||
    !sheetList ||
    !modal ||
    !modalBg ||
    !modalClose ||
    !modalBody ||
    !modalEdit ||
    !modalGo
  ){
    return;
  }

  function ensurePriceBadge(){
    if(priceBadge) return priceBadge;
    /* Sem caixa de preço não há onde pendurar o badge - devolve um elemento
       solto para quem chamar poder escrever nele sem verificar. */
    if(!priceCompare) return document.createElement("div");

    priceBadge = document.createElement("div");
    priceBadge.id = "rvPriceBadge";
    priceBadge.setAttribute(
      "style",
      "display:inline-flex;align-items:center;gap:6px;background:#001A33;color:#fff;padding:6px 10px;border-radius:999px;font-size:12px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;margin-bottom:10px;"
    );

    const priceBox = priceCompare.closest(".rvPriceBox");
    if(priceBox && priceCompare.parentNode === priceBox){
      priceBox.insertBefore(priceBadge, priceCompare);
    }

    return priceBadge;
  }

  function setInlineError(message){
    if(!inlineError) return;
    inlineError.textContent = message || "";
    inlineError.classList.toggle("is-show", Boolean(message));
  }

  function clearInlineError(){
    setInlineError("");
  }

  function setButtonState(button, enabled){
    button.disabled = !enabled;
    button.classList.toggle("is-disabled", !enabled);
  }

  function getCurrentKit(){
    return (kits[st.tipo] || []).find((item) => item.id === st.kit) || null;
  }

  /* A caixa de preço do configurador foi removida a pedido do MK
     (2026-08-22). Os elementos já não existem no HTML - os preços passaram a
     estar só nos cartões de kit (rvKitCard__sale) e no checkout.
     A função fica, e continua a ser chamada em vários sítios; escreve apenas
     no que existir, para o dia em que a caixa voltar. */
  function updatePriceBox(){
    const kit = getCurrentKit();
    if(!kit) return;

    if(priceCompare) priceCompare.textContent = `au lieu de ${fmtEUR(kit.compare)}`;
    if(priceMain)    priceMain.textContent    = fmtEURPlain(kit.sale);
    if(priceSave)    priceSave.textContent    = `Vous économisez ${fmtEUR(kit.save)}`;
    if(priceCompare) ensurePriceBadge().textContent = `${calcDiscount(kit.compare, kit.sale)} % DE RÉDUCTION`;
  }

  function renderKits(){
    const availableKits = kits[st.tipo] || [];
    if(!availableKits.length){
      kitGrid.innerHTML = "";
      st.kit = null;
      return;
    }

    if(!availableKits.some((item) => item.id === st.kit)){
      st.kit = availableKits[0].id;
    }

    kitGrid.innerHTML = "";

       availableKits.forEach((kit) => {
      const card = document.createElement("div");
      card.className = "rvKitCard" + (st.kit === kit.id ? " is-on" : "");
      card.setAttribute("role", "button");
      card.setAttribute("tabindex", "0");
      card.setAttribute("aria-pressed", st.kit === kit.id ? "true" : "false");
      card.innerHTML = `
        <div class="rvKitCard__tag${kit.tagType === 'best' ? ' rvKitCard__tag--green' : ''}">${escapeHtml(kit.tag)}</div>
        <div class="rvKitCard__media">
          <img src="${escapeHtml(fotoMini(fotoNaCor(kit.img)))}" alt="${escapeHtml(kit.nome)}" loading="lazy" decoding="async">
        </div>
        <div class="rvKitCard__content">
          <h3 class="rvKitCard__title">${escapeHtml(kit.nome)}</h3>
          <p class="rvKitCard__desc">${escapeHtml(kit.desc)}</p>
          <p class="rvKitCard__compare">${escapeHtml(fmtEUR(kit.compare))}</p>
          <p class="rvKitCard__sale">${escapeHtml(fmtEUR(kit.sale))}</p>
        </div>
      `;

      const selectKit = () => {
        st.kit = kit.id;
        renderKits();
        updatePriceBox();
        clearInlineError();

        const configBlock = btnMarca?.closest(".rvBlock");
        if(configBlock){
          window.setTimeout(() => {
            if (typeof window.smoothScrollToEl === "function") {
              window.smoothScrollToEl(configBlock, 120);
            } else {
              configBlock.scrollIntoView({ block: "start" });
            }
          }, 160);
        }
      };

      card.addEventListener("click", selectKit);
      card.addEventListener("keydown", (event) => {
        if(event.key === "Enter" || event.key === " "){
          event.preventDefault();
          selectKit();
        }
      });

      kitGrid.appendChild(card);
    });


    updatePriceBox();
  }

  function resetMarca(){
    st.marca = null;
    st.modelo = null;
    st.ano = null;
    txtMarca.textContent = "Choisir";
    txtModelo.textContent = "À renseigner";
    txtAno.textContent = "À renseigner";
    setButtonState(btnModelo, false);
    setButtonState(btnAno, false);
    aktualisierenFahrzeugkarte();
  }

  function resetModelo(){
    st.modelo = null;
    st.ano = null;
    txtModelo.textContent = "Choisir";
    txtAno.textContent = "À renseigner";
    setButtonState(btnAno, false);
    aktualisierenFahrzeugkarte();
  }

  function resetAno(){
    st.ano = null;
    txtAno.textContent = "Choisir";
    aktualisierenFahrzeugkarte();
  }



  // Logos oficiais das montadoras no seletor (pedido do Gabriel, 04/10/2026: "tem que ser a logo real").
  // Uma imagem por marca em images/m/marcas/<chave>.webp (origem de cada uma em ~/EdelCarSite/logos-marcas-fontes.json);
  // só carrega quando o seletor abre. Entrada manual fica sem símbolo quando não há logo oficial.
  const LOGO_V = "2";
  const MARCAS_COM_LOGO = new Set(["abarth", "aixam", "alfaromeo", "alpine", "astonmartin", "audi", "austin", "bedford", "bentley", "bmw", "byd", "cadillac", "chatenet", "chery", "chevrolet", "chrysler", "citroen", "cupra", "dacia", "daewoo", "daftrucks", "deepal", "dfsk", "daihatsu", "dodge", "dongfeng", "drmotor", "dsautomobiles", "emc", "evo", "ferrari", "fiat", "fisker", "ford", "geely", "genesis", "greatwall", "honda", "hyundai", "ichx", "ineos", "infiniti", "isuzu", "iveco", "jac", "jaecoo", "jaguar", "jeep", "kia", "lada", "lamborghini", "lancia", "landrover", "leapmotor", "lexus", "ligier", "lotus", "lucid", "lynkco", "mahindra", "man", "maserati", "maxus", "mazda", "mercedesbenz", "mg", "microcar", "mini", "mitsubishi", "morgan", "morris", "nio", "nissan", "omoda", "opel", "peugeot", "piaggio", "polestar", "porsche", "portaro", "proton", "ram", "renault", "rollsroyce", "rover", "saab", "seat", "skoda", "smart", "sportequipe", "ssangyongkgm", "subaru", "suzuki", "swm", "talbot", "tata", "tesla", "tiger", "togg", "toyota", "triumph", "umm", "vinfast", "volkswagen", "volvo", "xpeng", "zeekr"]);
  const chaveMarca = (n) => n.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");
  function logoMarca(nome){
    const k = chaveMarca(nome);
    if (MARCAS_COM_LOGO.has(k)) {
      return `<span class="rvMarcaLogo" aria-hidden="true"><img src="images/m/marcas/${k}.webp?v=${LOGO_V}" alt="" width="42" height="26" loading="lazy" decoding="async"></span>`;
    }
    return "";
  }

  /* Busca do seletor (pedido do Gabriel, 04/10/2026): o cliente pesquisa a marca,
     o modelo ou o ano e a lista vira sugestões, da mais parecida para a menos.
     Aceita sem acento, sem hífen, fora de ordem ("klasse e"), apelidos ("VW",
     "Benz") e erro de digitação ("volkswagon"), e na marca já sugere o modelo
     ("golf" mostra o Volkswagen Golf). Enter escolhe a primeira sugestão.
     A entrada livre fica em um formulário separado com marca, modelo e ano. */
  const TXT_BUSCA = {
    marcas: "Marques",
    modelos: "Modèles",
    nada: (q) => `Aucun résultat pour « ${q} »`,
    nadaSub: "Vérifiez l’orthographe ou choisissez dans la liste.",
    semOpcoes: "Aucune option disponible",
    verTudo: "Tout afficher",
    naoAchou: "Votre véhicule n’y est pas ? Saisissez-le vous-même",
    naoAchouSub: "Pas de souci : nous fabriquons sur mesure pour tous les véhicules.",
    phMarca: "Rechercher une marque, par ex. Peugeot",
    phModelo: (ex) => `Rechercher un modèle${ex ? `, par ex. ${ex}` : ""}`,
    phAno: "Rechercher une année, par ex. 2019",
    subModelo: (marca) => `${marca} · Modèle`,
    modeloFehlt: "Aucun modèle dans la liste pour cette marque. Saisissez-le vous-même : nous le fabriquons sur mesure.",
    anoFehlt: "Aucune année dans la liste. Saisissez-la vous-même : nous le fabriquons sur mesure."
  };

  const TXT_MANUAL = {
    title: "Vérifiez votre véhicule",
    sub: "Saisissez vos informations et vérifiez-les avant de confirmer",
    previewLeer: "Veuillez remplir tous les champs",
    previewFertig: "Prêt pour la fabrication sur mesure",
    erroMarca: "Indiquez la marque de votre véhicule.",
    erroModelo: "Indiquez le modèle de votre véhicule.",
    erroAno: "Indiquez une année valide à quatre chiffres.",
    aviso: "Nous fabriquons pour tous les véhicules. Il suffit d’indiquer la bonne marque, le bon modèle et la bonne année.",
    avisoSemModelo: (marca) => `Pas de souci : nous les fabriquons aussi sur mesure pour votre ${marca}. Indiquez le modèle et l’année.`,
    avisoSemAno: (nome) => `Pas de souci : indiquez l’année de votre ${nome}, nous les fabriquons sur mesure.`
  };

  const ordemAlfa = (a, b) => String(a).localeCompare(String(b), "fr", { sensitivity: "base", numeric: true });
  const marcasDisponiveis = () => Array.from(new Set(Object.keys(dadosCarros).concat(MARCAS_MERCADO))).sort(ordemAlfa);

  const APELIDOS_MARCA = {
    "Volkswagen": ["VW"],
    "Mercedes-Benz": ["MB", "Mercedes"],
    "Chevrolet": ["Chevy"],
    "Great Wall": ["GWM", "Haval"],
    "Land Rover": ["Range Rover"],
    "Rolls-Royce": ["Rolls"],
    "Mini": ["Mini Cooper"]
  };

  // Texto sem acento e sem símbolo, guardando a posição de cada letra no original (pro destaque).
  function prepararBusca(texto){
    const s = String(texto || "");
    const palavras = [];
    const mapa = [];
    let junto = "";
    let atual = null;
    for(let i = 0; i < s.length; i++){
      const c = s[i].normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
      if(c.length === 1 && /[a-z0-9]/.test(c)){
        if(!atual){
          atual = { t: "", c: junto.length };
          palavras.push(atual);
        }
        atual.t += c;
        junto += c;
        mapa.push(i);
      } else {
        atual = null;
      }
    }
    return { palavras, junto, mapa };
  }

  // Distância de edição com troca de letras vizinhas ("volkswagon" x "volkswagen" = 1).
  function distancia(a, b){
    const n = b.length;
    let ant2 = null;
    let ant = Array.from({ length: n + 1 }, (_, j) => j);
    for(let i = 1; i <= a.length; i++){
      const cur = [i];
      for(let j = 1; j <= n; j++){
        const custo = a[i - 1] === b[j - 1] ? 0 : 1;
        let v = Math.min(ant[j] + 1, cur[j - 1] + 1, ant[j - 1] + custo);
        if(ant2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, ant2[j - 2] + 1);
        cur.push(v);
      }
      ant2 = ant;
      ant = cur;
    }
    return ant[n];
  }

  function pontuar(item, q, comErro){
    const b = item._b || (item._b = prepararBusca(item.busca || item.t));
    const alvo = b.junto;
    const qj = q.junto;
    if(!alvo || !qj) return null;
    const faixa = (ini, fim) => [b.mapa[ini], b.mapa[fim - 1] + 1];

    if(alvo === qj) return { p: 1000, faixas: [faixa(0, qj.length)] };
    if(alvo.startsWith(qj)) return { p: 900, faixas: [faixa(0, qj.length)] };

    // Cada palavra digitada é o começo de uma palavra do nome, em qualquer ordem.
    const usadas = new Set();
    const fx = [];
    let todas = true;
    q.palavras.forEach((t) => {
      const i = b.palavras.findIndex((w, idx) => !usadas.has(idx) && w.t.startsWith(t.t));
      if(i < 0){
        todas = false;
        return;
      }
      usadas.add(i);
      fx.push(faixa(b.palavras[i].c, b.palavras[i].c + t.t.length));
    });
    if(todas) return { p: 800, faixas: fx };

    const meio = alvo.indexOf(qj);
    if(meio > 0 && qj.length >= 2) return { p: 600 - Math.min(meio, 90), faixas: [faixa(meio, meio + qj.length)] };
    if(fx.length && q.palavras.length > 1) return { p: 500 + fx.length * 20, faixas: fx };
    if(!comErro || qj.length < 4 || /^\d+$/.test(qj)) return null;

    // Erro de digitação: 1 letra (2 em nomes compridos), comparando com o começo do nome ou de uma palavra.
    const tol = qj.length >= 8 ? 2 : 1;
    let melhor = null;
    const testar = (txt, c0) => {
      for(let L = Math.max(4, qj.length - 1); L <= qj.length + 1 && L <= txt.length; L++){
        const d = distancia(qj, txt.slice(0, L));
        if(d <= tol && (!melhor || d < melhor.d)) melhor = { d, c0, L };
      }
    };
    testar(alvo, 0);
    b.palavras.forEach((w) => testar(w.t, w.c));
    if(!melhor) return null;
    return { p: 300 - melhor.d * 60, faixas: [faixa(melhor.c0, melhor.c0 + melhor.L)] };
  }

  // soNome: só entra quem bateu no próprio nome (o modelo não aparece só porque a marca bateu).
  function rankear(items, q, comErro, soNome){
    const out = [];
    items.forEach((item, idx) => {
      const r = pontuar(item, q, comErro);
      if(!r) return;
      const lim = item.t.length;
      const faixas = r.faixas.filter(([ini]) => ini < lim).map(([ini, fim]) => [ini, Math.min(fim, lim)]);
      if(soNome && !faixas.length) return;
      out.push(Object.assign({}, item, { faixas, _p: r.p, _i: idx }));
    });
    // Empate fica na ordem da lista (alfabética; nas sugestões de modelo, a dos mais vendidos).
    out.sort((a, b) => (b._p - a._p) || (a._i - b._i));
    // Com resposta certeira na lista, as que só bateram em parte saem.
    return out.length && out[0]._p >= 600 ? out.filter((x) => x._p >= 600) : out;
  }

  let cacheModelos = null;
  function todosModelos(){
    if(cacheModelos) return cacheModelos;
    cacheModelos = [];
    Object.keys(dadosCarros).forEach((marca) => {
      const apelidos = (APELIDOS_MARCA[marca] || []).join(" ");
      (dadosCarros[marca] || []).forEach(([modelo]) => {
        cacheModelos.push({
          t: modelo,
          busca: `${modelo} ${marca} ${apelidos}`,
          s: TXT_BUSCA.subModelo(marca),
          logo: marca,
          pick: () => {
            escolherMarca(marca);
            escolherModelo(modelo);
            proximoPasso();
          }
        });
      });
    });
    return cacheModelos;
  }

  function htmlVazio(consulta, tipo){
    return `
      <div class="rvSheet__vazio">
        <strong>${escapeHtml(TXT_BUSCA.nada(consulta))}</strong>
        <span>${escapeHtml(TXT_BUSCA.naoAchouSub)}</span>
        <button type="button" class="rvVehicleAction rvVehicleAction--primary rvSheet__vazioManual" data-manual-busca>${escapeHtml(TXT_BUSCA.naoAchou)} <span aria-hidden="true">›</span></button>
        <button type="button" class="rvSheet__vazioBtn" data-ver-tudo>${escapeHtml(TXT_BUSCA.verTudo)}</button>
      </div>
    `;
  }

  function tituloComDestaque(texto, faixas){
    if(!faixas || !faixas.length) return escapeHtml(texto);
    let html = "";
    let pos = 0;
    faixas.slice().sort((a, b) => a[0] - b[0]).forEach(([ini, fim]) => {
      if(ini < pos) return;
      html += escapeHtml(texto.slice(pos, ini)) + "<mark>" + escapeHtml(texto.slice(ini, fim)) + "</mark>";
      pos = fim;
    });
    return html + escapeHtml(texto.slice(pos));
  }

  function fillSheetList(items, vazio){
    sheetList.innerHTML = "";
    sheetList.scrollTop = 0;

    if(!items.length){
      sheetList.innerHTML = vazio || `<div class="rvSheet__vazio"><strong>${escapeHtml(TXT_BUSCA.semOpcoes)}</strong></div>`;
      return;
    }

    items.forEach((item) => {
      if(item.grupo){
        const g = document.createElement("div");
        g.className = "rvSheet__grupo";
        g.textContent = item.grupo;
        sheetList.appendChild(g);
        return;
      }
      const comLogo = !item.manual && (item.marca || item.logo);
      const row = document.createElement("button");
      row.type = "button";
      row.className = "rvSheet__item" + (comLogo ? " rvSheet__item--marca" : "") + (item.manual ? " rvSheet__item--manual" : "");
      row.innerHTML = `
        <div class="${comLogo ? "rvSheet__marca" : ""}">
          ${comLogo ? logoMarca(item.logo || item.t) : ""}
          <div>
            <div class="rvSheet__itemTitle">${tituloComDestaque(item.t, item.faixas)}</div>
            ${item.s ? `<div class="rvSheet__itemSub">${escapeHtml(item.s)}</div>` : ""}
          </div>
        </div>
        <div>›</div>
      `;
      row.addEventListener("click", () => {
        closeSheet();
        if(item.pick) item.pick();
        else sheetCtx?.onPick?.(item.val);
      });
      sheetList.appendChild(row);
    });
  }

  let sheetViewportFrame = 0;

  function atualizarViewportSheet(){
    if(!sheet.classList.contains("is-on")) return;
    if(sheetViewportFrame) cancelAnimationFrame(sheetViewportFrame);
    sheetViewportFrame = requestAnimationFrame(() => {
      const viewport = window.visualViewport;
      const altura = Math.round(viewport ? viewport.height : window.innerHeight);
      const topo = Math.round(viewport ? viewport.offsetTop : 0);
      sheet.style.setProperty("--rv-viewport-height", `${Math.max(240, altura)}px`);
      sheet.style.setProperty("--rv-viewport-top", `${Math.max(0, topo)}px`);
    });
  }

  window.visualViewport?.addEventListener("resize", atualizarViewportSheet);
  window.visualViewport?.addEventListener("scroll", atualizarViewportSheet);
  window.addEventListener("resize", atualizarViewportSheet);

function fahrzeugname(marke = st.marca, modell = st.modelo, jahr = st.ano){
  return [marke, modell, jahr].filter(Boolean).join(" ");
}

function aktualisierenFahrzeugkarte(){
  const anzahl = [st.marca, st.modelo, st.ano].filter(Boolean).length;
  const komplett = anzahl === 3;
  vehicleProgress.textContent = `${anzahl} information(s) sur 3`;
  vehicleResult.hidden = !komplett;
  vehicleResultName.textContent = komplett ? fahrzeugname() : "";
  sheetVehicleMarca.textContent = st.marca || "Choisir";
  sheetVehicleModelo.textContent = st.modelo || (st.marca ? "Choisir" : "À renseigner");
  sheetVehicleAno.textContent = st.ano || (st.modelo ? "Choisir" : "À renseigner");
  if(!st.marca) sheetVehicleValue.textContent = "Choisir la marque";
  else if(!st.modelo) sheetVehicleValue.textContent = `${st.marca} · Choisir le modèle`;
  else if(!st.ano) sheetVehicleValue.textContent = `${st.marca} ${st.modelo} · Choisir l’année`;
  else sheetVehicleValue.textContent = fahrzeugname();
}

function aktualisierenManuelleVorschau(){
  const marke = manualMarca.value.trim();
  const modell = manualModelo.value.trim();
  const jahr = manualAno.value.trim();
  if(manualError.textContent) manualError.textContent = "";
  const komplett = Boolean(marke && modell && anoManualValido(jahr));
  const markeText = marke || "Marque";
  const modellText = modell || "Modèle";
  const jahrText = jahr || "Année";
  manualVehicle.classList.toggle("is-complete", komplett);
  manualVehicleValue.textContent = `${markeText} ${modellText}, ${jahrText}`;
  manualVehicleStatus.textContent = komplett ? TXT_MANUAL.previewFertig : TXT_MANUAL.previewLeer;
}

function mostrarListaSheet(focar){
  if(!sheetCtx) return;
  sheet.classList.remove("is-manual");
  sheetManualForm.hidden = true;
  sheetSearchWrap.hidden = false;
  sheetManualOpen.hidden = false;
  sheetList.hidden = false;
  sheetVehicle.hidden = false;
  aktualisierenFahrzeugkarte();
  sheetTitle.textContent = sheetCtx.title;
  sheetSub.textContent = sheetCtx.sub || "Touchez une option";
  manualError.textContent = "";
  if(focar && window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches){
    setTimeout(() => {
      try { sheetSearch.focus({ preventScroll: true }); } catch(_){}
    }, 80);
  }
}

// 20/10/2026: abre ja com o que a pessoa digitou na busca (marca, modelo ou ano) e com a frase de confianca.
function abrirFormularioManual(opcoes = {}){
  sheet.classList.add("is-manual");
  sheetSearchWrap.hidden = true;
  sheetManualOpen.hidden = true;
  sheetList.hidden = true;
  sheetManualForm.hidden = false;
  sheetVehicle.hidden = true;
  sheetTitle.textContent = TXT_MANUAL.title;
  sheetSub.textContent = TXT_MANUAL.sub;
  const consulta = limparEntradaLivre(opcoes.consulta || "");
  let marca = st.marca || "", modelo = st.modelo || "", ano = st.ano || "";
  if(consulta && opcoes.tipo === "marca"){ marca = consulta; modelo = ""; ano = ""; }
  else if(consulta && opcoes.tipo === "modelo"){ modelo = consulta; ano = ""; }
  else if(consulta && opcoes.tipo === "ano" && /^\d{4}$/.test(consulta)) ano = consulta;
  manualMarca.value = marca;
  manualModelo.value = modelo;
  manualAno.value = ano;
  if(manualAviso) manualAviso.textContent = opcoes.aviso || TXT_MANUAL.aviso;
  manualError.textContent = "";
  aktualisierenManuelleVorschau();
  sheetSearch.blur();
  if(window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches){
    const primeiroVazio = [manualMarca, manualModelo, manualAno].find((campo) => !campo.value) || manualMarca;
    setTimeout(() => primeiroVazio.focus({ preventScroll: true }), 80);
  }
}

 function openSheet(ctx){
  sheetCtx = ctx;
  sheetSearch.value = "";
  sheetSearch.placeholder = ctx.placeholder || "";
  sheetSearch.setAttribute("inputmode", ctx.tipo === "ano" ? "numeric" : "search");
  atualizarLimpar();
  const hinweis = ctx.emptyText
    ? `<div class="rvSheet__vazio"><strong>${escapeHtml(ctx.emptyText)}</strong></div>`
    : "";
  fillSheetList(ctx.items, hinweis);
  mostrarListaSheet(false);
  sheet.classList.add("is-on");
  sheet.setAttribute("aria-hidden", "false");
  document.body.classList.add("rv-sheet-open");
  atualizarViewportSheet();
  // No computador o cursor já fica no campo; no celular o teclado abre quando o cliente toca nele.
  if(window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches){
    setTimeout(() => {
      try { sheetSearch.focus({ preventScroll: true }); } catch(_){}
    }, 80);
  }
}

function closeSheet(){
  sheet.classList.remove("is-on");
  sheet.classList.remove("is-manual");
  sheet.setAttribute("aria-hidden", "true");
  sheetSearch.value = "";
  sheetSearch.blur();
  sheetManualForm.hidden = true;
  sheetSearchWrap.hidden = false;
  sheetManualOpen.hidden = false;
  sheetList.hidden = false;
  sheetVehicle.hidden = false;
  atualizarLimpar();
  document.body.classList.remove("rv-sheet-open");
  if(sheetViewportFrame) cancelAnimationFrame(sheetViewportFrame);
  sheetViewportFrame = 0;
  sheet.style.removeProperty("--rv-viewport-height");
  sheet.style.removeProperty("--rv-viewport-top");
}

  function escolherMarca(marca){
    st.marca = marca;
    txtMarca.innerHTML = `${logoMarca(marca)}<span>${escapeHtml(marca)}</span>`;
    resetModelo();
    txtModelo.textContent = "Choisir le modèle";
    setButtonState(btnModelo, true);
    aktualisierenFahrzeugkarte();
    clearInlineError();
  }

  function escolherModelo(modelo){
    st.modelo = modelo;
    txtModelo.textContent = modelo;
    resetAno();
    txtAno.textContent = "Choisir l’année";
    setButtonState(btnAno, true);
    aktualisierenFahrzeugkarte();
    clearInlineError();
  }

  function escolherAno(ano){
    st.ano = String(ano);
    txtAno.textContent = String(ano);
    aktualisierenFahrzeugkarte();
    clearInlineError();
  }

  function limparEntradaLivre(valor){
    return String(valor || "").trim().replace(/\s+/g, " ").slice(0, 80);
  }

  function anoManualValido(valor){
    if(!/^\d{4}$/.test(valor)) return false;
    const ano = Number(valor);
    return ano >= 1900 && ano <= new Date().getFullYear() + 1;
  }

  // Escolheu a marca ou o modelo: já abre a lista seguinte (marca > modelo > ano). Sem isso o cliente
  // chegava no botão de comprar sem o ano e só via o aviso em alemão lá embaixo (print do Gabriel, 06/10/2026).
  function proximoPasso(){
    if(st.marca && !st.modelo) openModeloSheet();
    else if(st.modelo && !st.ano) openAnoSheet();
  }

  // Comprar com algo faltando: além do aviso, abre na hora a lista do que falta.
  function abrirOQueFalta(){
    if(!st.marca) openMarcaSheet();
    else if(!st.modelo) openModeloSheet();
    else if(!st.ano) openAnoSheet();
  }

  function openMarcaSheet(){
    // Marcas em ordem alfabética (pedido do Gabriel, 04/10/2026). dadosCarros
    // continua na ordem de popularidade, que é a usada nas sugestões de modelo.
    openSheet({
      title: "Choisir la marque",
      sub: "Recherchez ou sélectionnez une marque dans la liste",
      tipo: "marca",
      placeholder: TXT_BUSCA.phMarca,
      items: marcasDisponiveis().map((marca) => ({
        t: marca,
        val: marca,
        marca: true,
        busca: [marca].concat(APELIDOS_MARCA[marca] || []).join(" ")
      })),
      onPick: (marca) => { escolherMarca(marca); proximoPasso(); }
    });
  }

  function openModeloSheet(){
    if(!st.marca) return;
    // Modelos em ordem alfabética, com os números em ordem de valor (4, 5, 11, 19).
    // Sem legenda de anos: o passo seguinte só oferece os anos válidos do modelo.
    const lista = dadosCarros[st.marca] || [];
    const modelos = lista.map(([modelo]) => modelo).sort(ordemAlfa).map((modelo) => ({ t: modelo, val: modelo }));

    openSheet({
      title: "Choisir le modèle",
      sub: `${st.marca} · Rechercher ou choisir le modèle`,
      tipo: "modelo",
      placeholder: TXT_BUSCA.phModelo(lista[0]?.[0]),
      items: modelos,
      emptyText: TXT_BUSCA.modeloFehlt,
      onPick: (modelo) => { escolherModelo(modelo); proximoPasso(); }
    });
    if(!modelos.length) abrirFormularioManual({ aviso: TXT_MANUAL.avisoSemModelo(st.marca) });
  }

  function openAnoSheet(){
    if(!st.marca || !st.modelo) return;
    const faixa = (dadosCarros[st.marca] || []).find(([nome]) => nome === st.modelo)?.[1];
    const anos = faixa ? getYearsRange(faixa.inicio, faixa.fim) : [];

    openSheet({
      title: "Choisir l’année",
      sub: `${st.marca} • ${st.modelo} · Rechercher ou choisir l’année`,
      tipo: "ano",
      placeholder: TXT_BUSCA.phAno,
      items: anos.map((ano) => ({ t: String(ano), val: String(ano) })),
      emptyText: TXT_BUSCA.anoFehlt,
      onPick: escolherAno
    });
    if(!anos.length) abrirFormularioManual({ aviso: TXT_MANUAL.avisoSemAno(`${st.marca} ${st.modelo}`) });
  }

  function openModal(){
    const kit = getCurrentKit();
    modalBody.innerHTML = `
      <div class="rvModal__row"><b>Type</b><span>${escapeHtml(st.tipo === "picape" ? "Pick-up" : "VOITURE")}</span></div>
      <div class="rvModal__row"><b>Kit</b><span>${escapeHtml(kit?.nome || "")}</span></div>
      <div class="rvModal__row"><b>Marque</b><span>${escapeHtml(st.marca)}</span></div>
      <div class="rvModal__row"><b>Modèle</b><span>${escapeHtml(st.modelo)}</span></div>
      <div class="rvModal__row"><b>Année</b><span>${escapeHtml(st.ano)}</span></div>
      <div class="rvModal__row"><b>Couleur</b><span>${escapeHtml(labelCor(st.cor))}</span></div>
      <div class="rvModal__row"><b>Finition</b><span>${escapeHtml(labelTextura(st.textura))}</span></div>
      <div class="rvModal__row"><b>Total</b><span>${escapeHtml(fmtEUR(kit?.sale || 0))}</span></div>
    `;
    modal.classList.add("is-on");
    modal.setAttribute("aria-hidden", "false");
  }

  function closeModal(){
    modal.classList.remove("is-on");
    modal.setAttribute("aria-hidden", "true");
  }

  function validatePanel(){
    if(!st.kit) return "Veuillez choisir un kit.";
    if(!st.marca) return "Veuillez choisir la marque du véhicule.";
    if(!st.modelo) return "Veuillez choisir le modèle du véhicule.";
    if(!st.ano) return "Veuillez choisir l’année du véhicule.";
    if(!st.cor) return "Veuillez choisir la couleur des tapis.";
    if(!st.textura) return "Veuillez choisir la finition des tapis.";
    return "";
  }

  typeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const nextTipo = button.dataset.tipo || "carro";
      if(nextTipo === st.tipo) return;

      st.tipo = nextTipo;
      typeButtons.forEach((item) => {
        item.classList.toggle("is-on", item === button);
      });

      renderKits();
      clearInlineError();
    });
  });

  window.selectKitFromCatalog = function(cat) {
    let nextTipo = "carro";
    let nextKit = "carro_sem_porta";
    
    if (cat === "carro") {
      nextTipo = "carro";
      nextKit = "carro_sem_porta";
    } else if (cat === "carro-portamalas") {
      nextTipo = "carro";
      nextKit = "carro_com_porta";
    } else if (cat === "pickup") {
      nextTipo = "picape";
      nextKit = "picape_sem_cacamba";
    } else if (cat === "pickup-cacamba") {
      nextTipo = "picape";
      nextKit = "picape_com_cacamba";
    }
    
    // Set state
    st.tipo = nextTipo;
    st.kit = nextKit;
    
    // Update type buttons classes
    typeButtons.forEach((button) => {
      button.classList.toggle("is-on", button.dataset.tipo === st.tipo);
    });
    
    // Render and update box
    renderKits();
    updatePriceBox();
    clearInlineError();
  };

  btnMarca.addEventListener("click", openMarcaSheet);
  btnModelo.addEventListener("click", openModeloSheet);
  btnAno.addEventListener("click", openAnoSheet);
  vehicleFind.addEventListener("click", () => {
    if(st.marca && st.modelo && st.ano) openMarcaSheet();
    else abrirOQueFalta();
  });
  vehicleManual.addEventListener("click", () => {
    openMarcaSheet();
    abrirFormularioManual();
  });

  colorButtons.forEach((button) => {
    button.addEventListener("click", () => {
      st.cor = button.dataset.cor || "";
      colorButtons.forEach((item) => {
        item.classList.toggle("is-on", item === button);
      });
      mostrarCor();
      clearInlineError();
    });
  });

  textureButtons.forEach((button) => {
    button.addEventListener("click", () => {
      st.textura = button.dataset.textura || "";
      textureButtons.forEach((item) => {
        item.classList.toggle("is-on", item === button);
      });
      clearInlineError();
    });
  });

  sheetBg.addEventListener("click", closeSheet);
  sheetClose.addEventListener("click", closeSheet);
  sheetManualOpen.addEventListener("click", () => abrirFormularioManual());
  sheetManualBack.addEventListener("click", () => mostrarListaSheet(true));
  [manualMarca, manualModelo, manualAno].forEach((campo) => {
    campo.addEventListener("input", aktualisierenManuelleVorschau);
  });

  sheetManualForm.addEventListener("submit", (e) => {
    e.preventDefault();
    const marca = limparEntradaLivre(manualMarca.value);
    const modelo = limparEntradaLivre(manualModelo.value);
    const ano = limparEntradaLivre(manualAno.value);
    manualError.textContent = "";
    if(!marca){
      manualError.textContent = TXT_MANUAL.erroMarca;
      manualMarca.focus();
      return;
    }
    if(!modelo){
      manualError.textContent = TXT_MANUAL.erroModelo;
      manualModelo.focus();
      return;
    }
    if(!anoManualValido(ano)){
      manualError.textContent = TXT_MANUAL.erroAno;
      manualAno.focus();
      return;
    }
    escolherMarca(marca);
    escolherModelo(modelo);
    escolherAno(ano);
    closeSheet();
  });

  aktualisierenFahrzeugkarte();

  const sheetLimpar = document.getElementById("rvSheetLimpar");

  function atualizarLimpar(){
    if(sheetLimpar) sheetLimpar.hidden = !sheetSearch.value;
  }

  function filtrarSheet(){
    if(!sheetCtx) return;
    const consulta = sheetSearch.value.trim();
    const q = prepararBusca(consulta);
    if(!q.junto){
      fillSheetList(sheetCtx.items);
      sheetManualOpen.hidden = false;
      return;
    }
    const naMarca = sheetCtx.tipo === "marca" && q.junto.length >= 2;
    // Primeiro sem tolerância a erro; se nada bater, tenta de novo aceitando erro de digitação.
    let achados = rankear(sheetCtx.items, q, false);
    let modelos = naMarca ? rankear(todosModelos(), q, false, true).slice(0, 6) : [];
    if(!achados.length && !modelos.length){
      achados = rankear(sheetCtx.items, q, true);
      modelos = naMarca ? rankear(todosModelos(), q, true, true).slice(0, 6) : [];
    }
    let lista = achados;
    if(modelos.length){
      const blocoMarcas = achados.length ? [{ grupo: TXT_BUSCA.marcas }].concat(achados) : [];
      const blocoModelos = [{ grupo: TXT_BUSCA.modelos }].concat(modelos);
      const modelosAntes = !achados.length || modelos[0]._p > achados[0]._p;
      lista = modelosAntes ? blocoModelos.concat(blocoMarcas) : blocoMarcas.concat(blocoModelos);
    }
    fillSheetList(lista, htmlVazio(consulta, sheetCtx.tipo));
    // Sem resultado, o botao grande do meio ja abre o formulario: a caixa do rodape sai pra nao cobrir ele.
    sheetManualOpen.hidden = Boolean(sheetList.querySelector("[data-manual-busca]"));
  }

  sheetSearch.addEventListener("input", () => {
    atualizarLimpar();
    filtrarSheet();
  });

  sheetSearch.addEventListener("keydown", (e) => {
    if(e.key !== "Enter" || e.isComposing) return;
    e.preventDefault();
    const primeira = sheetList.querySelector("button.rvSheet__item");
    if(primeira) primeira.click();
  });

  sheetLimpar?.addEventListener("click", () => {
    sheetSearch.value = "";
    atualizarLimpar();
    filtrarSheet();
    sheetSearch.focus();
  });

  sheetList.addEventListener("click", (e) => {
    if(e.target.closest("[data-manual-busca]")){
      abrirFormularioManual({ consulta: sheetSearch.value.trim(), tipo: sheetCtx?.tipo });
    } else if(e.target.closest("[data-ver-tudo]")){
      sheetSearch.value = "";
      atualizarLimpar();
      filtrarSheet();
    } else if(e.target.closest("[data-fechar-sheet]")){
      closeSheet();
    }
  });

  modalBg.addEventListener("click", closeModal);
  modalClose.addEventListener("click", closeModal);
  modalEdit.addEventListener("click", closeModal);

  modalGo.addEventListener("click", () => {
    const url = resolveCheckoutUrl();
    if(!url){
      closeModal();
      setInlineError("Impossible de continuer. Vérifiez le kit et la couleur choisis.");
      return;
    }

    // Adiciona kit, montante e dados do veículo à URL de checkout
    const kitObj = kits[st.tipo]?.find(k => k.id === st.kit);
    const extraParams = new URLSearchParams();
    extraParams.set("kit", st.kit || "");
    if (kitObj) extraParams.set("amount", kitObj.sale);
    if (st.marca)   extraParams.set("marca", st.marca);
    if (st.modelo)  extraParams.set("modelo", st.modelo);
    if (st.ano)     extraParams.set("ano", st.ano);
    if (st.cor)     extraParams.set("cor", st.cor);
    if (st.textura) extraParams.set("textura", st.textura);
    const joinerExtra = url.includes("?") ? "&" : "?";
    const urlWithExtra = url + joinerExtra + extraParams.toString();

    // Anexa as UTMs persistidas (UTMify) à URL de checkout.
    let finalUrl;
    if (typeof window.ccBuildCheckoutUrl === "function") {
      finalUrl = window.ccBuildCheckoutUrl(urlWithExtra);
    } else {
      const qs = (window.location.search || "").replace(/^\?/, "");
      const joiner = urlWithExtra.includes("?") ? "&" : "?";
      finalUrl = urlWithExtra + (qs ? joiner + qs : "");
    }
    try {
      var tokenMatch = (url || "").match(/token=([^&]+)/);
      var contentId = tokenMatch ? tokenMatch[1] : "protectcar";
      var eid = "atc_" + contentId + "_" + Date.now();
      if (typeof window.metaTrack === "function") {
        window.metaTrack("AddToCart", {
          content_type: "product",
          content_ids: [contentId],
          currency: "EUR",
          num_items: 1
        }, eid);
      }
    } catch (e) {}
    window.location.href = finalUrl;
  });

  // Carrinho (04/10/2026): "Acheter maintenant" põe o set no carrinho; com o carrinho vazio vai direto ao
  // checkout, e se já havia outros itens abre o carrinho pra conferir antes. O botão do carrinho só
  // põe no carrinho e mostra.
  function colocarNoCarrinho(){
    const error = validatePanel();
    if(error){
      setInlineError(error);
      abrirOQueFalta();
      return false;
    }
    clearInlineError();
    if(!window.msCarrinho){
      setInlineError("Le panier n’a pas pu être chargé. Veuillez actualiser la page.");
      return false;
    }
    return window.msCarrinho.adicionar({
      kit: st.kit, tipo: st.tipo, cor: st.cor, textura: st.textura,
      marca: st.marca, modelo: st.modelo, ano: st.ano
    });
  }

  confirmBtn.addEventListener("click", () => {
    const antes = window.msCarrinho ? window.msCarrinho.quantidade() : 0;
    if(!colocarNoCarrinho()) return;
    if(antes > 0) window.msCarrinho.abrir({ adicionado: true });
    else window.msCarrinho.irParaCheckout();
  });

  document.getElementById("rvAddCartBtn")?.addEventListener("click", () => {
    if(colocarNoCarrinho()) window.msCarrinho.abrir({ adicionado: true });
  });

  typeButtons.forEach((button) => {
    button.classList.toggle("is-on", button.dataset.tipo === st.tipo);
  });

  colorButtons.forEach((button) => {
    button.classList.toggle("is-on", button.dataset.cor === st.cor);
  });

  textureButtons.forEach((button) => {
    button.classList.toggle("is-on", button.dataset.textura === st.textura);
  });

  // O carrinho (carrinho.js) usa os mesmos kits, rótulos, fotos por cor e links do checkout
  window.msConfig = {
    kits,
    labelCor,
    labelTextura,
    fotoKit: (src, cor) => fotoMini(fotoCor(src, cor)),
    checkoutLink: (kitId, cor) => checkoutLinks?.[kitId]?.[cor] || checkoutLinks?.[kitId]?.preto || null
  };

  resetMarca();
  mostrarCor();
})();

const specsToggle = document.getElementById("specsToggle");
const specsContent = document.getElementById("specsContent");

if (specsToggle && specsContent) {
  // Recolhido termina no fim de uma linha inteira (antes cortava a última linha pela metade, 05/10/2026).
  const LIMITE_SPECS = 300;
  const alturaSpecs = () => {
    if (specsContent.classList.contains("is-open")) return;
    const topo = specsContent.getBoundingClientRect().top;
    const rg = document.createRange();
    rg.selectNodeContents(specsContent);
    let fim = 0;
    for (const r of rg.getClientRects()) {
      const baixo = r.bottom - topo;
      if (r.height > 0 && r.height < 60 && baixo <= LIMITE_SPECS && baixo > fim) fim = baixo;
    }
    if (fim > 0) specsContent.style.maxHeight = Math.ceil(fim + 4) + "px";
  };
  alturaSpecs();
  window.addEventListener("resize", alturaSpecs);
  if ("IntersectionObserver" in window) {
    new IntersectionObserver((itens) => {
      if (itens.some((i) => i.isIntersecting)) { alturaSpecs(); setTimeout(alturaSpecs, 700); }
    }).observe(specsContent);
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(alturaSpecs);
  specsToggle.addEventListener("click", () => {
    const opened = specsContent.classList.toggle("is-open");
    specsContent.closest(".specs-section")?.classList.toggle("is-open", opened);
    specsContent.style.maxHeight = opened ? specsContent.scrollHeight + "px" : "";
    if (!opened) alturaSpecs();
    specsToggle.textContent = opened ? "Afficher moins" : "Afficher plus";
    specsToggle.classList.toggle("is-open", opened);
    specsToggle.setAttribute("aria-expanded", String(opened));
  });
}
// Smooth scroll manual - funciona mesmo com body como scroll container
// (overflow:hidden auto), onde scrollIntoView({behavior:'smooth'}) falha.
// Recalcula o alvo a cada frame: lazy-load de imagens muda a altura da
// página durante o scroll, então um targetY fixo "erra" o destino.
function smoothScrollToEl(el, offset) {
  if (!el) return;
  offset = offset == null ? 120 : offset; // compensa header sticky

  const getY = () => window.pageYOffset
    || document.body.scrollTop
    || document.documentElement.scrollTop || 0;
  // behavior:"instant" é obrigatório - sem ele, o CSS scroll-behavior:smooth
  // transforma cada frame numa animação própria e trava o scroll manual.
  const setY = (y) => {
    try { window.scrollTo({ top: y, behavior: "instant" }); } catch (e) { window.scrollTo(0, y); }
    try { document.body.scrollTo({ top: y, behavior: "instant" }); } catch (e) { document.body.scrollTop = y; }
    try { document.documentElement.scrollTo({ top: y, behavior: "instant" }); } catch (e) { document.documentElement.scrollTop = y; }
  };
  // posição absoluta do elemento no documento, menos o offset do header
  const targetNow = () => Math.max(0, el.getBoundingClientRect().top + getY() - offset);

  // NÃO cortar aqui por prefers-reduced-motion: a máquina do dono do site
  // tem "reduzir movimento" ligado no Windows e o scroll ficava aos saltos.
  // Decisão dele: o deslize tem de ser suave sempre.
  const startY = getY();
  if (Math.abs(targetNow() - startY) < 2) return;

  const duration = 650;
  const t0 = performance.now();
  const ease = t => (t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2, 3)/2);
  let done = false;

  // Se o utilizador mexer no scroll a meio, a animação DESISTE. Sem isto os
  // snaps de segurança lá em baixo (300/700/1100/1600 ms) puxavam a página
  // de volta ao destino durante 1,6 s - dava a sensação de scroll preso
  // logo a seguir a escolher o kit, mesmo com a roda do rato a girar.
  let cancelado = false;
  const timers = [];
  const EVENTOS = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
  const limpar = () => {
    timers.forEach(clearTimeout);
    EVENTOS.forEach(t => window.removeEventListener(t, cancelar));
  };
  function cancelar() {
    cancelado = true;
    done = true;
    limpar();
  }
  EVENTOS.forEach(t => window.addEventListener(t, cancelar, { passive: true }));

  function step(now) {
    if (done || cancelado) return;
    const t = Math.min((now - t0) / duration, 1);
    // alvo recalculado a cada frame - corrige o drift do lazy-load
    const target = targetNow();
    const y = startY + (target - startY) * ease(t);
    setY(y);
    if (t < 1) {
      requestAnimationFrame(step);
    } else {
      done = true;
      setY(targetNow());
      limpar();
    }
  }
  requestAnimationFrame(step);

  // FALLBACK GARANTIDO via setTimeout - requestAnimationFrame é pausado
  // quando a aba está em background; setTimeout sempre dispara. Esses
  // snaps garantem que o scroll chega ao destino mesmo sem rAF, e também
  // corrigem o drift do lazy-load depois da animação.
  [300, 700, 1100, 1600].forEach((delay) => {
    timers.push(setTimeout(() => {
      if (cancelado) return;            // o utilizador assumiu o controlo
      // se a animação rAF ainda está rodando, deixa ela terminar
      if (!done && delay < 700) return;
      done = true;
      setY(targetNow());
      if (delay === 1600) limpar();
    }, delay));
  });
}
// expõe global pra ser usada também dentro do IIFE do configurador
window.smoothScrollToEl = smoothScrollToEl;

(function bindVslJump() {
  const vslJumpBtn = document.getElementById("vslJumpBtn");
  if (!vslJumpBtn) return;
  vslJumpBtn.addEventListener("click", (e) => {
    e.preventDefault();
    // re-query no clique - garante elemento válido mesmo se DOM mudou
    const target = document.getElementById("cta");
    if (target && typeof window.smoothScrollToEl === "function") {
      window.smoothScrollToEl(target, 120);
    } else if (target) {
      target.scrollIntoView({ block: "start" });
    }
  });
})();
function initVehiclePulse(){
  const cards = Array.from(document.querySelectorAll(".vehicleRow"));
  if(cards.length < 2) return;

  if(window.vehiclePulseTimer){
    clearTimeout(window.vehiclePulseTimer);
  }

  let index = 0;
  let stopped = false;

  function pulseNext(){
    if(stopped) return;

    const current = cards[index];
    if(!current) return;

    current.classList.add("is-pulsing");

    setTimeout(() => {
      current.classList.remove("is-pulsing");

      index++;
      const finishedRound = index >= cards.length;

      if(finishedRound){
        index = 0;
      }

      window.vehiclePulseTimer = setTimeout(
        pulseNext,
        finishedRound ? 1800 : 450
      );
    }, 1250);
  }

  cards.forEach(card => {
    card.addEventListener("pointerdown", () => {
      stopped = true;
      clearTimeout(window.vehiclePulseTimer);
      cards.forEach(c => c.classList.remove("is-pulsing"));
    }, { once: true });
  });

  pulseNext();
}
